// src/index.ts
import {
  init,
  createFetchExecutor,
  resolveExecutor as resolveExecutor24,
  resetDefaultExecutor
} from "@hopdrive/sdk-core";

// src/features/get-move/get-move.generated.ts
import { resolveExecutor } from "@hopdrive/sdk-core";
var GetMoveByIdDocument = { "__text": "query GetMoveById($where: moves_bool_exp!) {\n  moves(where: $where, limit: 1) {\n    id\n    status\n    move_type\n    cancel_status\n    customer_id\n    driver_id\n    lane_id\n    payer_id\n    ready_by\n    deliver_by\n    pickup_time\n    delivery_time\n    pickup_started\n    pickup_arrived\n    pickup_successful\n    delivery_started\n    delivery_arrived\n    delivery_successful\n    vehicle_make\n    vehicle_model\n    vehicle_year\n    vehicle_color\n    vehicle_vin\n    vehicle_stock\n    vehicle_odometer\n    priority\n    reference_num\n    manual_flag\n    config\n    tags\n    consumer_name\n    consumer_phone\n    dealer_contact\n    sla_id\n    workflowset_id\n    pickup_workflow_id\n    delivery_workflow_id\n    pickup_workflow_data\n    delivery_workflow_data\n    createdat\n    updatedat\n    lane {\n      id\n      distance_miles\n      duration_sec\n      pickup {\n        id\n        name\n        address\n        latitude\n        longitude\n      }\n      delivery {\n        id\n        name\n        address\n        latitude\n        longitude\n      }\n    }\n    sla {\n      id\n      name\n      label\n      description\n      duration_hrs\n    }\n    workflowset {\n      id\n      name\n      description\n    }\n    customer {\n      id\n      name\n    }\n    payer {\n      id\n      name\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetMoveById" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "moves_bool_exp" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "driver_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_started" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_arrived" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_successful" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_started" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_arrived" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_successful" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_stock" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_odometer" } }, { "kind": "Field", "name": { "kind": "Name", "value": "priority" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "manual_flag" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tags" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "dealer_contact" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sla_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_workflow_data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_workflow_data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "sla" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "label" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_hrs" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "payer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] } }] };
async function getMoveById(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor(executor).query(
    GetMoveByIdDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.moves;
}

// src/features/get-move/get-move.ts
async function getMove(params) {
  const where = {
    id: { _eq: params.id }
  };
  if (params.customerId !== void 0) {
    where.customer_id = { _eq: params.customerId };
  }
  const result = await getMoveById({ where }, { executor: params.executor });
  return result[0] ?? null;
}

// src/features/update-move/update-move.ts
import { resolveExecutor as resolveExecutor3 } from "@hopdrive/sdk-core";

// src/features/update-move/gql/updateMove.mutation.generated.ts
import { resolveExecutor as resolveExecutor2 } from "@hopdrive/sdk-core";
var UpdateMoveDocument = { "__text": "mutation UpdateMove($id: bigint!, $set: moves_set_input!) {\n  update_moves(where: {id: {_eq: $id}}, _set: $set) {\n    affected_rows\n    returning {\n      id\n      vehicle_year\n      vehicle_make\n      vehicle_model\n      vehicle_color\n      vehicle_stock\n      vehicle_vin\n      ready_by\n      reference_num\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateMove" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "set" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "moves_set_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "set" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_stock" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }] } }] } }] } }] };

// src/features/update-move/update-move.ts
async function updateMove(params) {
  const executor = resolveExecutor3(params.executor);
  const result = await executor.mutate(UpdateMoveDocument, {
    id: params.id,
    set: params.set
  });
  return result.update_moves?.returning[0] ?? null;
}

// src/features/cancel-dependent-rides/cancel-dependent-rides.ts
import { resolveExecutor as resolveExecutor23 } from "@hopdrive/sdk-core";

// src/features/cancel-dependent-rides/gql/getCanceledDriveScenarioLegs.query.generated.ts
import { resolveExecutor as resolveExecutor4 } from "@hopdrive/sdk-core";
var GetCanceledDriveScenarioLegsDocument = { "__text": "query GetCanceledDriveScenarioLegs($moveId: bigint!) {\n  moves_by_pk(id: $moveId) {\n    id\n    move_type\n    cancel_status\n    scenariotomoves {\n      scenario {\n        id\n        moves {\n          move {\n            id\n            move_type\n            active\n            cancel_status\n            status\n            createdBy\n            ridehails {\n              id\n              status\n            }\n            scenariotomoves {\n              scenario {\n                id\n                moves {\n                  move {\n                    id\n                    move_type\n                    active\n                    cancel_status\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetCanceledDriveScenarioLegs" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenariotomoves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenario" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdBy" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ridehails" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenariotomoves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenario" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] };

// src/features/create-move/add-move-to-scenario.ts
import { resolveExecutor as resolveExecutor21 } from "@hopdrive/sdk-core";
import { z as z3 } from "zod";

// src/features/create-move/gql/addMoveToScenario.mutation.generated.ts
import { resolveExecutor as resolveExecutor5 } from "@hopdrive/sdk-core";
var AddMoveToScenarioDocument = { "__text": "mutation AddMoveToScenario($link: scenariotomoves_insert_input!) {\n  insert_scenariotomoves_one(object: $link) {\n    id\n    move_id\n    cardinality\n    scenario {\n      id\n      scenario_key\n      status\n      product_key\n      usecase_key\n      customer_id\n      moves(order_by: {cardinality: asc}) {\n        cardinality\n        move_id\n        createdby\n        move {\n          id\n          status\n          move_type\n          usecase_key\n          customer_id\n          lane_id\n          parent_move_id\n          lite\n          ready_by\n          deliver_by\n          pickup_time\n          consumer_type\n          consumer_name\n          consumer_phone\n          reference_num\n          vehicle_vin\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "AddMoveToScenario" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "link" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "scenariotomoves_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_scenariotomoves_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "link" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cardinality" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }] } }] } }] } }] } }] } }] };

// src/features/create-move/gql/getScenarioForLegAdd.query.generated.ts
import { resolveExecutor as resolveExecutor6 } from "@hopdrive/sdk-core";
var GetScenarioForLegAddDocument = { "__text": "query GetScenarioForLegAdd($scenarioId: bigint!) {\n  scenarios_by_pk(id: $scenarioId) {\n    id\n    scenario_key\n    status\n    product_key\n    usecase_key\n    customer_id\n    moves(order_by: {cardinality: asc}) {\n      cardinality\n      move_id\n      createdby\n      move {\n        id\n        status\n        move_type\n        usecase_key\n        customer_id\n        lane_id\n        parent_move_id\n        lite\n        ready_by\n        deliver_by\n        pickup_time\n        consumer_type\n        consumer_name\n        consumer_phone\n        reference_num\n        vehicle_vin\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenarioForLegAdd" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cardinality" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }] } }] } }] } }] } }] };
async function getScenarioForLegAdd(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor6(executor).query(
    GetScenarioForLegAddDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.scenarios_by_pk;
}

// src/features/create-move/errors.ts
var RequestVehicleMoveErrorCode = {
  /** The input failed schema validation, or a use case's required peer input is missing. */
  INVALID_INPUT: "INVALID_INPUT",
  /** `usecase_key` is a real use case but this creator does not build it yet. */
  UNSUPPORTED_USECASE: "UNSUPPORTED_USECASE",
  /** No `products` row carries the declared `product_key`. */
  PRODUCT_NOT_FOUND: "PRODUCT_NOT_FOUND",
  /** The product exists but is an accounting or retired row, so it cannot be purchased. */
  PRODUCT_NOT_PURCHASABLE: "PRODUCT_NOT_PURCHASABLE",
  /** Both keys are real, but this product does not sell that use case. */
  PRODUCT_USECASE_INCOMPATIBLE: "PRODUCT_USECASE_INCOMPATIBLE",
  /**
   * A full-service move whose primary lane has no end in a region HopDrive
   * serves. The same refusal as legacy's `errors.codes.OUTSIDE_REGION`.
   * Details: `lane_id`, `pickup_region_status`, `delivery_region_status`. See
   * `location-rule.ts`.
   */
  OUTSIDE_REGION: "OUTSIDE_REGION",
  /**
   * A Valet Lite move whose primary lane has both ends more than the rooftop's
   * service radius plus the grace from the rooftop. Details: `lane_id`,
   * `radius_miles`, `pickup_miles`, `delivery_miles`, in whole miles. See
   * `location-rule.ts`.
   */
  OUTSIDE_SERVICE_RADIUS: "OUTSIDE_SERVICE_RADIUS",
  /**
   * A lane the request uses has no route yet, so its legs cannot be timed.
   * Enrichment is still running, or the lane could not be read. A retry once
   * the lane is `ready` succeeds. Details: `lane_id`, `leg`, `lane_status`,
   * `reason` (`not_enriched` | `lookup_failed`).
   */
  LANE_NOT_READY: "LANE_NOT_READY",
  /**
   * A lane the request uses has `status = failed` and no route. Nothing
   * re-enriches it on its own, so a retry fails the same way until someone
   * fixes the address or re-enriches the lane. Details: `lane_id`, `leg`,
   * `lane_status`.
   */
  LANE_ENRICHMENT_FAILED: "LANE_ENRICHMENT_FAILED",
  /** The write reached the database and failed there. */
  PERSISTENCE_FAILED: "PERSISTENCE_FAILED",
  /** The write succeeded but returned a scenario that does not satisfy the invariant. */
  SCENARIO_INCOMPLETE: "SCENARIO_INCOMPLETE"
};
var RETRYABLE = /* @__PURE__ */ new Set([
  RequestVehicleMoveErrorCode.PERSISTENCE_FAILED,
  RequestVehicleMoveErrorCode.LANE_NOT_READY
]);
var RequestVehicleMoveError = class extends Error {
  constructor(code, message, details = {}, options) {
    super(`[requestVehicleMove] ${message}`);
    this.name = "RequestVehicleMoveError";
    if (options && "cause" in options) this.cause = options.cause;
    this.code = code;
    this.details = Object.freeze({ ...details });
    this.retryable = RETRYABLE.has(code);
  }
};
function isRequestVehicleMoveError(err) {
  return err instanceof Error && err.name === "RequestVehicleMoveError";
}
var AddMoveToScenarioErrorCode = {
  /** The input failed schema validation. Includes a missing or empty `reason`. */
  INVALID_INPUT: "INVALID_INPUT",
  /**
   * No `scenarios` row carries that id.
   *
   * This is the boundary between this function and `requestVehicleMove`, spelled
   * as a refusal. An unknown `scenario_id` is never an invitation to create one.
   */
  SCENARIO_NOT_FOUND: "SCENARIO_NOT_FOUND",
  /** The scenario exists but belongs to a different customer than the caller declared. */
  SCENARIO_FORBIDDEN: "SCENARIO_FORBIDDEN",
  /**
   * The scenario carries no `product_key` and its existing legs do not agree on
   * `moves.lite`, so the new leg's Lite-ness cannot be derived from the
   * scenario and this function will not accept it from a caller.
   *
   * The wrong value prices a Lite move at full contract rates, and a later
   * write cannot fix it because `lite` is not in the `db-moves` event trigger's
   * `update.columns`, so `assignPriceOverride` never runs.
   */
  SCENARIO_IDENTITY_UNKNOWN: "SCENARIO_IDENTITY_UNKNOWN",
  /** A read or a write reached the database and failed there. */
  PERSISTENCE_FAILED: "PERSISTENCE_FAILED",
  /** The write succeeded but returned a row that does not satisfy the invariant. */
  SCENARIO_INCOMPLETE: "SCENARIO_INCOMPLETE"
};
var ADD_RETRYABLE = /* @__PURE__ */ new Set([AddMoveToScenarioErrorCode.PERSISTENCE_FAILED]);
var AddMoveToScenarioError = class extends Error {
  constructor(code, message, details = {}, options) {
    super(`[addMoveToScenario] ${message}`);
    this.name = "AddMoveToScenarioError";
    if (options && "cause" in options) this.cause = options.cause;
    this.code = code;
    this.details = Object.freeze({ ...details });
    this.retryable = ADD_RETRYABLE.has(code);
  }
};
function isAddMoveToScenarioError(err) {
  return err instanceof Error && err.name === "AddMoveToScenarioError";
}

// src/features/create-move/creation-log.ts
import { getLogger } from "@hopdrive/sdk-core";

// src/features/create-move/provenance.ts
import { z } from "zod";
var ACTOR_TYPES = ["user", "integrator", "system", "embed-hmac"];
var LOGGABLE = /^[A-Za-z0-9][A-Za-z0-9_.:/-]*$/;
var ActorSchema = z.object({
  type: z.enum(ACTOR_TYPES),
  /** A user id, client id, partner name or job name. Never an email or a credential. */
  id: z.string().min(1).max(128).regex(LOGGABLE, "actor.id must be an id or a name, not an email"),
  /** The actor's role, when it has one, e.g. `admin`, `dealer`, `sixt-approver`. */
  role: z.string().min(1).max(64).regex(LOGGABLE).optional()
}).strict();
var EntryPointSchema = z.string().min(1).max(128).regex(LOGGABLE);
function isEmbedHmacSession(session) {
  return session?.["x-hasura-role"] === "dealer" && session?.["x-hasura-user-id"] === "0";
}
function loggable(value, max) {
  return typeof value === "string" && value.length <= max && LOGGABLE.test(value);
}
function actorFromHasuraSession(session) {
  if (!session || typeof session !== "object") return void 0;
  if (isEmbedHmacSession(session)) {
    const rooftop = Number(session["x-hasura-customer-id"]);
    return Number.isSafeInteger(rooftop) && rooftop > 0 ? { type: "embed-hmac", id: `rooftop-${rooftop}` } : void 0;
  }
  const userId = session["x-hasura-user-id"];
  if (!loggable(userId, 128)) return void 0;
  const role = session["x-hasura-role"];
  return { type: "user", id: userId, ...loggable(role, 64) ? { role } : {} };
}

// src/features/create-move/creation-log.ts
var SCHEMA_VERSION = 1;
var FEATURE = "move-creation";
var REFUSAL_CODES = /* @__PURE__ */ new Set([
  "INVALID_INPUT",
  "UNSUPPORTED_USECASE",
  "PRODUCT_NOT_FOUND",
  "PRODUCT_NOT_PURCHASABLE",
  "PRODUCT_USECASE_INCOMPATIBLE",
  "OUTSIDE_REGION",
  "OUTSIDE_SERVICE_RADIUS",
  // A failed lane stays failed until someone fixes it. LANE_NOT_READY is not
  // here: it is retryable, so it counts as a failure.
  "LANE_ENRICHMENT_FAILED",
  "SCENARIO_NOT_FOUND",
  "SCENARIO_FORBIDDEN",
  "SCENARIO_IDENTITY_UNKNOWN"
]);
var ERROR_DETAIL_KEYS = [
  "scenario_id",
  "move_id",
  "lane_id",
  "legs",
  "cardinality",
  "product_key",
  "usecase_key",
  "scenario_key",
  "reason",
  "leg",
  "salable",
  "active",
  "declared_customer_id",
  "pickup_region_status",
  "delivery_region_status",
  "radius_miles",
  "pickup_miles",
  "delivery_miles",
  "lane_status"
];
var TOKEN = /^[A-Za-z0-9][A-Za-z0-9_.:/-]{0,79}$/;
function id(value) {
  return typeof value === "number" && Number.isSafeInteger(value) && value > 0 ? value : null;
}
function token(value) {
  return typeof value === "string" && TOKEN.test(value) ? value : null;
}
function record(value) {
  return value !== null && typeof value === "object" ? value : {};
}
function errorName(err) {
  try {
    return err instanceof Error ? token(err.name) : null;
  } catch {
    return null;
  }
}
function detailValue(value) {
  if (value === null || typeof value === "boolean") return value;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  return token(value);
}
function safeLog(level, event, build, logger) {
  try {
    const data = build();
    const pending = (logger ?? getLogger())[level](event, data);
    if (pending && typeof pending.catch === "function") {
      ;
      pending.catch(() => void 0);
    }
  } catch {
  }
}
var ACTOR_TYPES2 = new Set(ACTOR_TYPES);
function sourceFields(raw) {
  const source = record(raw.source);
  const requestId = typeof source.request_id === "string" && source.request_id ? source.request_id : null;
  const actor = record(raw.actor);
  const actorType = typeof actor.type === "string" && ACTOR_TYPES2.has(actor.type) ? actor.type : null;
  return {
    source_channel: token(source.channel),
    request_id: requestId,
    has_request_id: requestId !== null,
    entry_point: token(source.entry_point) ?? "unspecified",
    // `token` has no `@`, so an email in `id` logs as null even before the
    // input schema refuses it.
    actor_type: actorType ?? "unknown",
    actor_id: actorType ? token(actor.id) : null,
    actor_role: actorType ? token(actor.role) : null
  };
}
function requestFields(rawInput) {
  const raw = record(rawInput);
  const loanerLeg = record(raw.loanerLeg);
  return {
    product_key: token(raw.product_key),
    usecase_key: token(raw.usecase_key),
    scenario_key: null,
    customer_id: id(raw.customer_id),
    payer_id: id(raw.payer_id),
    lane_id: id(raw.lane_id),
    ride_lane_id: id(raw.rideLaneId),
    loaner_lane_id: id(raw.loanerLaneId) ?? id(loanerLeg.lane_id),
    ...sourceFields(raw)
  };
}
function legAddFields(rawInput) {
  const raw = record(rawInput);
  const leg = record(raw.leg);
  return {
    product_key: null,
    usecase_key: null,
    scenario_key: null,
    customer_id: id(raw.customer_id),
    payer_id: id(leg.payer_id),
    lane_id: id(leg.lane_id),
    scenario_id: id(raw.scenario_id),
    leg_reason: token(raw.reason),
    ...sourceFields(raw)
  };
}
function resultFields(boundary, result) {
  const scenario = record(result.scenario);
  const legs = [result.move, ...result.peerMoves ?? []].map((m) => record(m)).sort((a, b) => Number(a.cardinality) - Number(b.cardinality));
  const common = {
    scenario_id: id(scenario.id),
    scenario_key: token(scenario.scenario_key),
    replayed: result.replayed === true
  };
  if (boundary === "addMoveToScenario") {
    return {
      ...common,
      product_key: token(scenario.product_key),
      usecase_key: token(scenario.usecase_key),
      move_id: id(record(result.move).id)
    };
  }
  return {
    ...common,
    move_ids: legs.map((m) => id(m.id)),
    leg_count: legs.length
  };
}
function errorFields(err) {
  const e = record(err);
  const typed = err instanceof Error && (e.name === "RequestVehicleMoveError" || e.name === "AddMoveToScenarioError") && typeof e.code === "string";
  if (!typed) {
    return {
      outcome: "failed",
      fields: {
        error_code: "UNEXPECTED",
        retryable: null,
        error_detail: { error_name: errorName(err) }
      }
    };
  }
  const code = e.code;
  const details = record(e.details);
  const detail = {};
  for (const key of ERROR_DETAIL_KEYS) {
    if (key in details) detail[key] = detailValue(details[key]);
  }
  if (Array.isArray(details.issues)) {
    detail.issue_paths = details.issues.map((issue) => {
      const path = record(issue).path;
      return Array.isArray(path) ? token(path.map(String).join(".") || "(root)") : null;
    }).filter((p) => p !== null).slice(0, 20);
  }
  const retryable = e.retryable === true;
  return {
    outcome: REFUSAL_CODES.has(code) && !retryable ? "refused" : "failed",
    fields: { error_code: token(code), retryable, error_detail: detail }
  };
}
var TERMINAL = {
  created: { event: "move_creation.created", level: "info" },
  replayed: { event: "move_creation.replayed", level: "warn" },
  refused: { event: "move_creation.refused", level: "warn" },
  failed: { event: "move_creation.failed", level: "error" }
};
function startCreationTrace(boundary, rawInput, logger) {
  const startedAt = Date.now();
  let base = {};
  try {
    base = boundary === "requestVehicleMove" ? requestFields(rawInput) : legAddFields(rawInput);
  } catch {
    base = { entry_point: "unspecified", actor_type: "unknown", actor_id: null, actor_role: null };
  }
  const missing = [
    ...base.actor_type === "unknown" ? ["actor"] : [],
    ...base.entry_point === "unspecified" ? ["entry_point"] : []
  ];
  if (missing.length > 0) {
    safeLog("warn", "move_creation.provenance_missing", () => ({
      event: "move_creation.provenance_missing",
      schema_version: SCHEMA_VERSION,
      boundary,
      feature: FEATURE,
      missing,
      customer_id: base.customer_id ?? null,
      source_channel: base.source_channel ?? null,
      entry_point: base.entry_point,
      actor_type: base.actor_type
    }), logger);
  }
  const envelope = (event) => ({
    event,
    schema_version: SCHEMA_VERSION,
    boundary,
    feature: FEATURE,
    ...base
  });
  const terminal = (outcome, extra) => {
    const { event, level } = TERMINAL[outcome];
    safeLog(level, event, () => ({
      ...envelope(event),
      ...extra(),
      outcome,
      duration_ms: Date.now() - startedAt
    }), logger);
  };
  return {
    started() {
      safeLog("debug", "move_creation.started", () => envelope("move_creation.started"), logger);
    },
    step(step, known) {
      try {
        if (known) {
          for (const key of ["scenario_key", "product_key", "usecase_key"]) {
            const value = token(known[key]);
            if (value !== null) base = { ...base, [key]: value };
          }
        }
      } catch {
      }
      safeLog("debug", "move_creation.step", () => ({ ...envelope("move_creation.step"), step }), logger);
    },
    succeeded(result) {
      const replayed = (() => {
        try {
          return result.replayed === true;
        } catch {
          return false;
        }
      })();
      terminal(replayed ? "replayed" : "created", () => resultFields(boundary, result));
    },
    threw(err) {
      let classified;
      try {
        classified = errorFields(err);
      } catch {
        classified = { outcome: "failed", fields: { error_code: "UNEXPECTED", retryable: null } };
      }
      const detail = record(classified.fields.error_detail);
      terminal(classified.outcome, () => ({
        ...classified.fields,
        // A failure's own detail names the blueprint it tried, when nothing
        // earlier did.
        ...base.scenario_key == null && typeof detail.scenario_key === "string" ? { scenario_key: detail.scenario_key } : {}
      }));
    }
  };
}

// src/features/create-move/consumer-phone.ts
function normalizeConsumerPhone(raw) {
  const trimmed = raw.trim();
  if (/\p{L}/u.test(trimmed)) return trimmed;
  let digits = trimmed.replace(/[^0-9]/g, "");
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  return digits.length === 10 ? digits : trimmed;
}

// src/features/create-move/gql/getProductForRequest.query.generated.ts
import { resolveExecutor as resolveExecutor7 } from "@hopdrive/sdk-core";
var GetProductForRequestDocument = { "__text": "query GetProductForRequest($productKey: String!) {\n  products(where: {key: {_eq: $productKey}}, limit: 1) {\n    id\n    key\n    salable\n    active\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProductForRequest" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "products" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }] } }] } }] };
async function getProductForRequest(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor7(executor).query(
    GetProductForRequestDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.products;
}

// src/features/create-move/product-identity.ts
var PRODUCT_USECASE_COMPATIBILITY = {
  "valet-lite": [
    "concierge-pu",
    "concierge-ret",
    "concierge-loaner-pu",
    "concierge-loaner-ret",
    "one-way",
    "round-trip"
  ],
  "valet-full-service": [
    "concierge-pu",
    "concierge-ret",
    "concierge-loaner-pu",
    "concierge-loaner-ret",
    "one-way",
    "round-trip"
  ],
  /**
   * The brokered load, which CarsArrive, Central Dispatch and Super Dispatch
   * create. The integration passes this key itself. It is business intent the
   * integration owns, and no broker rooftop holds a `contracts` row to infer it
   * from.
   *
   * `one-way` only. Each integration creates a single A-to-B drive with a
   * stranded-driver ride leg, which is `one-way`'s blueprint.
   *
   * Not in `LITE_PRODUCT_KEYS`. A brokered load is not a Lite Valet move.
   */
  "operational-moves": ["one-way"]
};
function productsSelling(usecaseKey, ownedProductKeys, compatibility = PRODUCT_USECASE_COMPATIBILITY) {
  const owned = new Set(ownedProductKeys);
  return Object.keys(compatibility).filter(
    (key) => owned.has(key) && compatibility[key].includes(usecaseKey)
  );
}
var LITE_PRODUCT_KEYS = /* @__PURE__ */ new Set(["valet-lite"]);
function isLiteProduct(productKey) {
  return LITE_PRODUCT_KEYS.has(productKey);
}
async function assertProductSellsUseCase(params) {
  const { productKey, usecaseKey, executor } = params;
  let rows;
  try {
    rows = await getProductForRequest({ productKey }, { executor });
  } catch (cause) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.PERSISTENCE_FAILED,
      `Could not read product "${productKey}".`,
      { product_key: productKey },
      { cause }
    );
  }
  const product = rows?.[0];
  if (!product) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.PRODUCT_NOT_FOUND,
      `No product has key "${productKey}".`,
      { product_key: productKey }
    );
  }
  if (!product.salable || !product.active) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.PRODUCT_NOT_PURCHASABLE,
      `Product "${productKey}" is not a purchasable offering (salable=${product.salable}, active=${product.active}).`,
      { product_key: productKey, salable: product.salable, active: product.active }
    );
  }
  const sold = PRODUCT_USECASE_COMPATIBILITY[productKey];
  if (!sold || !sold.includes(usecaseKey)) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.PRODUCT_USECASE_INCOMPATIBLE,
      `Product "${productKey}" does not sell use case "${usecaseKey}". It sells: ${sold?.length ? sold.join(", ") : "nothing yet"}.`,
      { product_key: productKey, usecase_key: usecaseKey, sells: sold ?? [] }
    );
  }
}
var ProductSelectionOutcome = {
  /** Exactly one owned product sells the use case, and it may be sold now. */
  SELECTED: "selected",
  /** Nothing the customer holds sells this use case. */
  NONE_OWNED: "none-owned",
  /** More than one does, and no tie-break resolved it. The keys are returned. */
  AMBIGUOUS: "ambiguous",
  /** Exactly one does, but the entitlement authority refuses a new request. */
  UNAVAILABLE: "unavailable"
};
var VALET_TIER_TIE_BREAK = ["valet-full-service", "valet-lite"];
async function selectOwnedProduct(params) {
  const {
    usecaseKey,
    ownedProductKeys,
    canCreateNew,
    tieBreak,
    compatibility = PRODUCT_USECASE_COMPATIBILITY
  } = params;
  const selling = new Set(productsSelling(usecaseKey, ownedProductKeys, compatibility));
  const candidates = [...new Set(ownedProductKeys)].filter((key) => selling.has(key));
  if (candidates.length === 0) {
    return { outcome: ProductSelectionOutcome.NONE_OWNED, candidates: [] };
  }
  const creatable = canCreateNew ? await creatableCandidates(candidates, canCreateNew) : candidates;
  if (creatable.length === 0) {
    return { outcome: ProductSelectionOutcome.UNAVAILABLE, product_key: candidates[0], candidates };
  }
  let productKey;
  if (creatable.length === 1) {
    productKey = creatable[0];
  } else if (tieBreak) {
    productKey = tieBreak.find((key) => creatable.includes(key));
  }
  if (productKey === void 0) {
    return { outcome: ProductSelectionOutcome.AMBIGUOUS, candidates: creatable };
  }
  return { outcome: ProductSelectionOutcome.SELECTED, product_key: productKey, candidates };
}
async function creatableCandidates(candidates, canCreateNew) {
  const allowed = await Promise.all(candidates.map((key) => canCreateNew(key)));
  return candidates.filter((_, index) => allowed[index]);
}

// src/features/create-move/request-input.ts
import { z as z2 } from "zod";

// src/types/enums.ts
var MoveStatus = {
  PENDING: "pending",
  DISPATCHED: "dispatched",
  PICKUP_STARTED: "pickup started",
  PICKUP_ARRIVED: "pickup arrived",
  PICKUP_SUCCESSFUL: "pickup successful",
  DELIVERY_STARTED: "delivery started",
  DELIVERY_ARRIVED: "delivery arrived",
  DELIVERY_SUCCESSFUL: "delivery successful",
  CANCELLED: "cancelled",
  FAILED: "failed"
};
var MoveType = {
  DRIVE: "drive",
  RIDE: "ride"
};
var CancelStatus = {
  PENDING: "pending",
  STARTED: "started",
  SEEN: "seen",
  DELIVERED: "delivered"
};
var RideType = {
  AUTO: "auto",
  LYFT: "lyft",
  SHUTTLE: "shuttle",
  UBER: "uber"
};
var ConsumerType = {
  CUSTOMER: "customer",
  LOANER: "loaner"
};
var ScenarioStatus = {
  NEW: "new",
  READY: "ready",
  PENDING: "pending",
  UNCONFIRMED: "unconfirmed",
  CONFIRMING: "confirming",
  MANUAL: "manual",
  AUTO: "auto",
  DISPATCHED: "dispatched",
  DECLINED: "declined",
  DEPRECATED: "deprecated"
};
var ScenarioKey = {
  CONCIERGE_PICKUP: "concierge-pu",
  CONCIERGE_PICKUP_NO_RIDESHARE: "concierge-pu-no-rideshare",
  CONCIERGE_LOANER_PICKUP: "concierge-loaner-pu",
  CONCIERGE_RETURN: "concierge-ret",
  CONCIERGE_RETURN_NO_RIDESHARE: "concierge-ret-no-rideshare",
  CONCIERGE_LOANER_RETURN: "concierge-loaner-ret",
  STRANDED_RIDESHARE_AFTER: "stranded-rideshare-after",
  STRANDED_NO_RIDESHARE: "stranded-no-rideshare",
  /**
   * The plain two-leg round trip, and the only round-trip key any creator
   * produces at creation time. `round-trip-rideshare-after`, `-before`, `-both`
   * and the `round-trip-flex*` family exist in `@hopdrive/sdk-dispatch` and are
   * reached by conversion after dispatch decides a ride is needed, never by a
   * customer request.
   */
  ROUND_TRIP: "round-trip"
};
var UseCaseKey = {
  CONCIERGE_PICKUP: "concierge-pu",
  CONCIERGE_LOANER_PICKUP: "concierge-loaner-pu",
  CONCIERGE_RETURN: "concierge-ret",
  CONCIERGE_LOANER_RETURN: "concierge-loaner-ret",
  ONE_WAY: "one-way",
  ROUND_TRIP: "round-trip"
};
var MoveRequestType = {
  CONCIERGE: "concierge",
  CONCIERGE_LOANER: "concierge-loaner",
  ONE_WAY: "one-way",
  ROUND_TRIP: "round-trip"
};
var MoveRequestDirection = {
  PICKUP: "pickup",
  RETURN: "return"
};

// src/features/create-move/request-input.ts
var SUPPORTED_USE_CASE_KEYS = [
  UseCaseKey.CONCIERGE_PICKUP,
  UseCaseKey.CONCIERGE_LOANER_PICKUP,
  UseCaseKey.CONCIERGE_RETURN,
  UseCaseKey.CONCIERGE_LOANER_RETURN,
  UseCaseKey.ONE_WAY,
  UseCaseKey.ROUND_TRIP
];
var CONCIERGE_USE_CASES = /* @__PURE__ */ new Set([
  UseCaseKey.CONCIERGE_PICKUP,
  UseCaseKey.CONCIERGE_LOANER_PICKUP,
  UseCaseKey.CONCIERGE_RETURN,
  UseCaseKey.CONCIERGE_LOANER_RETURN
]);
var RETURN_USE_CASES = /* @__PURE__ */ new Set([
  UseCaseKey.CONCIERGE_RETURN,
  UseCaseKey.CONCIERGE_LOANER_RETURN
]);
var VehicleSchema = z2.object({
  vin: z2.string().optional(),
  make: z2.string().optional(),
  model: z2.string().optional(),
  year: z2.string().optional(),
  color: z2.string().optional(),
  stock: z2.string().optional(),
  odometer: z2.number().optional(),
  /**
   * Transmission. Writes `moves.manual_flag`, which dispatch reads to avoid
   * offering the move to a driver who cannot drive a stick. Absent leaves the
   * column at its `false` default rather than writing a null.
   */
  manual: z2.boolean().optional(),
  /**
   * Writes `moves.vehicle_gross_weight_lbs`, which decides the class of
   * driver and equipment a move needs. Every leg of every use case writes it,
   * paired legs included.
   */
  gross_weight_lbs: z2.number().optional()
}).strict();
var MoveLegSchema = z2.object({
  /** This leg's lane. For a round-trip return leg, the inverse of `lane_id`. */
  lane_id: z2.number().int().positive(),
  vehicle: VehicleSchema.optional(),
  /** Defaults to the top-level `ready_by`. */
  ready_by: z2.string().min(1).optional(),
  reference_num: z2.string().optional(),
  dealer_contact: z2.string().optional(),
  move_details: z2.string().optional(),
  config: z2.record(z2.unknown()).optional(),
  /**
   * This leg's own workflowset, because two legs of one request can run
   * different workflows. Defaults to the top-level `workflowset_id`, and
   * through it to the customer's configured default. Inheriting the
   * top-level value first matches this contract's fallback rule for every
   * other leg field.
   */
  workflowset_id: z2.number().int().positive().optional(),
  /**
   * This leg's SLA, overriding the one its workflowset resolves. Defaults to
   * the top-level `sla_id`, and through it to the resolved value. Each leg's
   * SLA comes from its own workflowset, so the two legs can differ.
   */
  sla_id: z2.number().int().positive().optional(),
  /**
   * The `moves.pickup_workflow_data` / `moves.delivery_workflow_data` jsonb
   * columns, per leg and never inherited from another leg. They carry one
   * vehicle's inspection payload, and attaching it to a second vehicle would
   * be worse than dropping it.
   */
  pickup_workflow_data: z2.record(z2.unknown()).optional(),
  delivery_workflow_data: z2.record(z2.unknown()).optional(),
  /**
   * This leg's earliest availability, when the caller already knows it.
   *
   * Normally omitted, and the boundary derives it from the business hours of
   * the lane's two locations and this leg's `ready_by`. Supply it only when
   * you know something the derivation cannot. It is refused if it is
   * unparseable or earlier than that leg's `ready_by`, the same invariant the
   * derivation guarantees.
   *
   * Falls back to the top-level value, then to the derived one.
   */
  earliest_available_time: z2.string().min(1).optional()
}).strict();
var ContactSchema = z2.object({
  name: z2.string().optional(),
  mobile_number: z2.string().optional(),
  landline_number: z2.string().optional(),
  email: z2.string().optional(),
  notes: z2.string().optional(),
  created_by_user_id: z2.number().int().positive().optional(),
  created_by_type: z2.string().optional()
}).strict();
var RequestVehicleMoveInputSchema = z2.object({
  customer_id: z2.number().int().positive(),
  /**
   * The salable product the customer is buying. Required, and validated
   * against `products` before anything is written. The scenario owns product
   * identity, so a scenario without one is not a transaction AR can price.
   */
  product_key: z2.string().min(1),
  usecase_key: z2.enum(SUPPORTED_USE_CASE_KEYS),
  lane_id: z2.number().int().positive(),
  ready_by: z2.string().min(1),
  // concierge-pu variants
  includeRide: z2.boolean().optional(),
  rideLaneId: z2.number().int().positive().optional(),
  // concierge-loaner-pu inputs
  /** Lane for the loaner leg (dealer → customer home). Inverse of `lane_id`. */
  loanerLaneId: z2.number().int().positive().optional(),
  /** Vehicle info for the loaner. Customer vehicle goes in `vehicle`. */
  loanerVehicle: VehicleSchema.optional(),
  /** Ready-by for the loaner leg. Defaults to top-level `ready_by`. */
  loanerReadyBy: z2.string().optional(),
  /**
   * The loaner leg in full, the nested alternative to the three flattened
   * `loaner*` fields above, for a loaner that needs its own commercial detail.
   * Passing it together with any flattened `loaner*` field is refused rather
   * than merged, because a silent precedence rule between two spellings of one
   * leg is how a request loses a field nobody notices.
   */
  loanerLeg: MoveLegSchema.optional(),
  // round-trip input
  /**
   * The return leg, B back to A. Required for `round-trip` and refused
   * everywhere else.
   */
  returnLeg: MoveLegSchema.optional(),
  vehicle: VehicleSchema.optional(),
  consumer_name: z2.string().optional(),
  consumer_phone: z2.string().transform(normalizeConsumerPhone).optional(),
  reference_num: z2.string().optional(),
  dealer_contact: z2.string().optional(),
  payer_id: z2.number().int().positive().optional(),
  workflowset_id: z2.number().int().positive().optional(),
  sla_id: z2.number().int().positive().optional(),
  move_details: z2.string().optional(),
  config: z2.record(z2.unknown()).optional(),
  /** The primary leg's workflow payloads. See `MoveLegInput`. */
  pickup_workflow_data: z2.record(z2.unknown()).optional(),
  delivery_workflow_data: z2.record(z2.unknown()).optional(),
  /**
   * The shared earliest availability, and the primary leg's. See
   * `MoveLegInput.earliest_available_time`. Omit it and every drive leg
   * derives its own.
   */
  earliest_available_time: z2.string().min(1).optional(),
  /**
   * The pickup and delivery contacts, linked to every drive leg of the
   * request and never to a ride.
   *
   * Written by this call, after the moves and before the scenario is
   * released to `pending`, because `determineConfirmationRequirement` reads
   * them then and skips straight to `ready` when a contact its flow needs is
   * missing. A contact written after this call returns arrives too late.
   * They never cost the move: see `ContactsOutcome` on the result.
   */
  contacts: z2.object({
    pickup: ContactSchema.optional(),
    delivery: ContactSchema.optional()
  }).strict().optional(),
  /**
   * The requested time came from a chosen slot on a named driver's row in
   * the schedule timeline, so hold it.
   *
   * It is a business fact rather than a persistence flag, which is why it is
   * not spelled `pinnable`. The SDK records it as `pinnable: true` on every
   * drive leg, so the admin plan editor treats `pickup_time` as fixed rather
   * than reflowing it.
   *
   * It only adds a reason to pin. A concierge pickup is pinned anyway because
   * it has a committed appointment time, and `scheduled: false` does not
   * unpin it.
   */
  scheduled: z2.boolean().optional(),
  /**
   * Provenance, and the caller's own idempotency key when it has one.
   * With `request_id` present a retry returns the existing scenario instead
   * of creating a second one.
   */
  source: z2.object({
    channel: z2.string().min(1),
    request_id: z2.string().min(1).optional(),
    /** The specific origin, for the creation log. See `provenance.ts`. */
    entry_point: EntryPointSchema.optional()
  }).strict().optional(),
  /** Who initiated the call, for the creation log. See `provenance.ts`. */
  actor: ActorSchema.optional(),
  user: z2.string().optional()
}).strict();
var DEFAULT_USER = "sdk-moves:requestVehicleMove";
function parseRequestInput(rawInput) {
  const parsed = RequestVehicleMoveInputSchema.safeParse(rawInput);
  if (!parsed.success) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `Input failed validation: ${parsed.error.issues.map((i) => `${i.path.join(".") || "(root)"}: ${i.message}`).join("; ")}`,
      { issues: parsed.error.issues }
    );
  }
  const input = parsed.data;
  return input;
}

// src/features/create-move/gql/getBusinessHoursForLocations.query.generated.ts
import { resolveExecutor as resolveExecutor8 } from "@hopdrive/sdk-core";
var GetBusinessHoursForLocationsDocument = { "__text": 'query GetBusinessHoursForLocations($locationIds: [bigint!]!) {\n  businesshours(\n    where: {type: {_neq: "federal-holiday"}, _or: [{location_id: {_in: $locationIds}}, {_and: {location_id: {_is_null: true}, type: {_eq: "default-hours"}}}]}\n  ) {\n    id\n    location_id\n    type\n    name\n    is_open\n    open_time\n    closed_time\n    day\n    day_of_week\n    week_of_month\n    month\n    year\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetBusinessHoursForLocations" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "locationIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "businesshours" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_neq" }, "value": { "kind": "StringValue", "value": "federal-holiday", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "location_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "locationIds" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "location_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "default-hours", "block": false } }] } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_open" } }, { "kind": "Field", "name": { "kind": "Name", "value": "open_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "closed_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "day" } }, { "kind": "Field", "name": { "kind": "Name", "value": "day_of_week" } }, { "kind": "Field", "name": { "kind": "Name", "value": "week_of_month" } }, { "kind": "Field", "name": { "kind": "Name", "value": "month" } }, { "kind": "Field", "name": { "kind": "Name", "value": "year" } }] } }] } }] };
async function getBusinessHoursForLocations(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor8(executor).query(
    GetBusinessHoursForLocationsDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.businesshours;
}

// src/features/create-move/business-hours.ts
function utcDate(d) {
  return d.toISOString().slice(0, 10);
}
function utcTime(d) {
  return d.toISOString().slice(11, 19);
}
function atUtc(date, time) {
  return /* @__PURE__ */ new Date(`${date}T${time}Z`);
}
function addSeconds(d, seconds) {
  return new Date(d.getTime() + seconds * 1e3);
}
function addDays(d, days) {
  return new Date(d.getTime() + days * 864e5);
}
function weekOfMonthSundayAnchored(d) {
  const firstDayOfWeek = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)).getUTCDay();
  return Math.floor((d.getUTCDate() - 1 + firstDayOfWeek) / 7) + 1;
}
function rowClosesAt(row, time) {
  return !row.is_open || (row.open_time ?? "") >= time || (row.closed_time ?? "") <= time;
}
function locationIsClosed(businessHours, at) {
  const dayOfMonth = at.getUTCDate();
  const month = at.getUTCMonth() + 1;
  const year = at.getUTCFullYear();
  const dayOfWeek = at.getUTCDay();
  const weekOfMonth = weekOfMonthSundayAnchored(at);
  const time = utcTime(at);
  const oneOff = businessHours.find(
    (bh) => bh.type === "one-off" && bh.day === dayOfMonth && bh.month === month && bh.year === year
  );
  if (oneOff && rowClosesAt(oneOff, time)) return oneOff;
  const holiday = businessHours.find(
    (bh) => (bh.type === "customer-holiday" || bh.type === "hopdrive-holiday") && (bh.day === dayOfMonth && bh.month === month || bh.month === month && bh.week_of_month === weekOfMonth && bh.day_of_week === dayOfWeek)
  );
  if (holiday && rowClosesAt(holiday, time)) return holiday;
  for (const own of businessHours.filter(
    (bh) => bh.location_id !== null && bh.type === "business-hours" && bh.day_of_week === dayOfWeek
  )) {
    if (rowClosesAt(own, time)) return own;
  }
  const fallback = businessHours.find(
    (bh) => bh.type === "default-hours" && bh.day_of_week === dayOfWeek
  );
  if (fallback && rowClosesAt(fallback, time)) return fallback;
  return null;
}
function findMatchingBusinessHours(businessHours, at) {
  const dayOfMonth = at.getUTCDate();
  const month = at.getUTCMonth() + 1;
  const year = at.getUTCFullYear();
  const dayOfWeek = at.getUTCDay();
  const weekOfMonth = Math.ceil((dayOfMonth - 1 - dayOfWeek) / 7);
  return businessHours.filter((bh) => {
    if (bh.type === "one-off") {
      return bh.day === dayOfMonth && bh.month === month && bh.year === year;
    }
    if (bh.type === "customer-holiday" || bh.type === "hopdrive-holiday") {
      return bh.day === dayOfMonth && bh.month === month || bh.month === month && bh.week_of_month === weekOfMonth && bh.day_of_week === dayOfWeek;
    }
    if (bh.type === "business-hours" || bh.type === "default-hours") {
      return bh.day_of_week === dayOfWeek;
    }
    return false;
  });
}
var START_TIME_PRECEDENCE = [
  (r) => r.type === "one-off",
  (r) => r.type === "customer-holiday" || r.type === "hopdrive-holiday",
  (r) => r.type === "business-hours",
  (r) => r.type === "default-hours"
];
function findStartTime(matchingHours) {
  for (const isKind of START_TIME_PRECEDENCE) {
    const open = matchingHours.filter((r) => isKind(r) && r.is_open && r.open_time).map((r) => r.open_time);
    if (open.length > 0) return open.sort()[0];
  }
  return null;
}
var BusinessHoursUnavailableError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "BusinessHoursUnavailableError";
  }
};
function findEarliestOpenTime(params) {
  const { pickupHours, deliveryHours, readyBy, durationSec } = params;
  const dayCount = params.dayCount ?? 1;
  if (pickupHours.length === 0 || deliveryHours.length === 0) {
    throw new BusinessHoursUnavailableError(
      "No business hours found for the pickup or delivery location."
    );
  }
  if (dayCount > 7) {
    throw new BusinessHoursUnavailableError("Failed to find an open day 7 times in a row.");
  }
  const candidatePickup = addDays(readyBy, dayCount);
  const candidateDelivery = addSeconds(candidatePickup, durationSec);
  const matchingPickup = findMatchingBusinessHours(pickupHours, candidatePickup);
  const matchingDelivery = findMatchingBusinessHours(deliveryHours, candidateDelivery);
  if (matchingPickup.some((bh) => !bh.is_open) || matchingDelivery.some((bh) => !bh.is_open)) {
    return findEarliestOpenTime({ ...params, dayCount: dayCount + 1 });
  }
  const openAt = findStartTime(matchingPickup);
  if (!openAt) {
    throw new BusinessHoursUnavailableError(
      `No opening time on ${utcDate(candidatePickup)} for the pickup location.`
    );
  }
  return atUtc(utcDate(candidatePickup), openAt);
}
function calcEarliestAvailableTime(params) {
  const { pickupHours, deliveryHours, readyBy, durationSec } = params;
  const estimatedDeliveryBy = addSeconds(readyBy, durationSec);
  const pickupClosure = locationIsClosed(pickupHours, readyBy);
  const deliveryClosure = locationIsClosed(deliveryHours, estimatedDeliveryBy);
  if (pickupClosure?.open_time && utcTime(readyBy) <= pickupClosure.open_time) {
    return atUtc(utcDate(readyBy), pickupClosure.open_time);
  }
  if (!pickupClosure && deliveryClosure?.open_time && utcTime(estimatedDeliveryBy) <= deliveryClosure.open_time) {
    return atUtc(utcDate(readyBy), deliveryClosure.open_time);
  }
  if (pickupClosure || deliveryClosure) {
    return findEarliestOpenTime({ pickupHours, deliveryHours, readyBy, durationSec });
  }
  return null;
}
async function resolveEarliestAvailableTime(params) {
  const { originLocationId, destinationLocationId, readyBy, durationSec, executor } = params;
  if (!originLocationId || !destinationLocationId) return null;
  const readyByDate = new Date(readyBy);
  if (Number.isNaN(readyByDate.getTime())) return null;
  let rows;
  try {
    rows = await getBusinessHoursForLocations(
      { locationIds: [originLocationId, destinationLocationId] },
      { executor }
    );
  } catch {
    return null;
  }
  if (!rows || rows.length === 0) return null;
  const forLocation = (id2) => rows.filter((r) => r.location_id === id2 || r.location_id === null);
  try {
    const earliest = calcEarliestAvailableTime({
      pickupHours: forLocation(originLocationId),
      deliveryHours: forLocation(destinationLocationId),
      readyBy: readyByDate,
      durationSec
    });
    return earliest ? earliest.toISOString() : null;
  } catch {
    return null;
  }
}

// src/features/create-move/gql/getSlaByName.query.generated.ts
import { resolveExecutor as resolveExecutor9 } from "@hopdrive/sdk-core";
var GetSlaByNameDocument = { "__text": "query GetSlaByName($name: String!) {\n  slas(where: {name: {_eq: $name}}, limit: 1) {\n    id\n    duration_hrs\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetSlaByName" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "name" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "slas" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "name" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_hrs" } }] } }] } }] };
async function getSlaByName(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor9(executor).query(
    GetSlaByNameDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.slas;
}

// src/features/create-move/gql/getWorkflowsetForMove.query.generated.ts
import { resolveExecutor as resolveExecutor10 } from "@hopdrive/sdk-core";
var GetWorkflowsetForMoveDocument = { "__text": "query GetWorkflowsetForMove($id: Int!, $moveTime: timestamptz!) {\n  workflowsets_by_pk(id: $id) {\n    id\n    pickup_workflow_id\n    delivery_workflow_id\n    config\n    raterulegroups(\n      where: {begin_date: {_lte: $moveTime}, _or: [{end_date: {_gte: $moveTime}}, {end_date: {_is_null: true}}]}\n      order_by: {begin_date: desc}\n      limit: 1\n    ) {\n      id\n      sla {\n        id\n        duration_hrs\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetWorkflowsetForMove" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "workflowsets_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterulegroups" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveTime" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveTime" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sla" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_hrs" } }] } }] } }] } }] } }] };
async function getWorkflowsetForMove(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor10(executor).query(
    GetWorkflowsetForMoveDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.workflowsets_by_pk;
}

// ../../gql/operations.ts
import { resolveExecutor as resolveExecutor11 } from "@hopdrive/sdk-core";

// ../../gql/schema.ts
var GetLaneByIdDocument = { "__text": "query GetLaneById($id: bigint!) {\n  lanes_by_pk(id: $id) {\n    id\n    active\n    status\n    updatedat\n    customer_id\n    origin_location_id\n    destination_location_id\n    description\n    distance_miles\n    duration_sec\n    tolls\n    favorite\n    route_polyline\n    route_metadata\n    enriched_at\n    enrichment_source\n    creation_criteria\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetLaneById" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "lanes_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "origin_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "destination_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "route_polyline" } }, { "kind": "Field", "name": { "kind": "Name", "value": "route_metadata" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enriched_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enrichment_source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "creation_criteria" } }] } }] } }] };

// ../../gql/operations.ts
async function getLaneById(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor11(executor).query(
    GetLaneByIdDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.lanes_by_pk;
}

// src/features/create-move/resolve-defaults.ts
import { getCustomerConfig } from "@hopdrive/sdk-configs";

// src/features/create-move/workflow-overrides.ts
var MoveWorkflowRole = {
  /** A drive with no consumer at either end: one-way and round-trip. */
  OPERATIONAL: "operational",
  /** The customer's own vehicle in a valet scenario. */
  VALET_CUSTOMER: "valet_customer",
  /** The dealer's loaner in a valet scenario. */
  VALET_LOANER: "valet_loaner"
};
function workflowRoleForConsumerType(consumerType) {
  if (consumerType === ConsumerType.LOANER) return MoveWorkflowRole.VALET_LOANER;
  if (consumerType === ConsumerType.CUSTOMER) return MoveWorkflowRole.VALET_CUSTOMER;
  return MoveWorkflowRole.OPERATIONAL;
}
function readMoveWorkflowOverrides(config) {
  if (!isRecord(config)) return null;
  const overrides = config.move_workflow_overrides;
  return isRecord(overrides) ? overrides : null;
}
function effectiveWorkflows(workflowset, role) {
  const override = workflowset.workflowOverrides?.[role];
  const pick = (value, fallback) => isWorkflowId(value) ? value : fallback;
  return {
    pickup_workflow_id: pick(override?.pickup_workflow_id, workflowset.pickup_workflow_id),
    delivery_workflow_id: pick(override?.delivery_workflow_id, workflowset.delivery_workflow_id)
  };
}
function isWorkflowId(value) {
  return typeof value === "number" && Number.isInteger(value) && value > 0;
}
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

// src/features/create-move/resolve-defaults.ts
var CONCIERGE_SLA_NAME = "default_concierge";
var FALLBACK_CONCIERGE_SLA = { id: 1, duration_hrs: 48 };
var FALLBACK_WORKFLOWSET = {
  id: 1,
  pickup_workflow_id: 1,
  delivery_workflow_id: 2,
  workflowOverrides: null,
  sla: null
};
var DEFAULT_SLA_NAME = "default";
var FALLBACK_DEFAULT_SLA = { id: 1, duration_hrs: 48 };
async function resolveConciergeSla(executor) {
  try {
    const slas = await getSlaByName({ name: CONCIERGE_SLA_NAME }, { executor });
    const sla = slas?.[0];
    if (sla) return { id: sla.id, duration_hrs: sla.duration_hrs ?? null };
  } catch {
  }
  return FALLBACK_CONCIERGE_SLA;
}
async function resolveWorkflowset(params) {
  const { inputWorkflowsetId, customerId, moveTime, executor } = params;
  let workflowsetId = inputWorkflowsetId;
  if (!workflowsetId) {
    try {
      const config = await getCustomerConfig({ customerId, executor });
      const defaultId = config?.default_workflow_set_id;
      if (typeof defaultId === "number") workflowsetId = defaultId;
    } catch {
    }
  }
  if (workflowsetId) {
    try {
      const ws = await getWorkflowsetForMove(
        { id: workflowsetId, moveTime: moveTime ?? (/* @__PURE__ */ new Date()).toISOString() },
        { executor }
      );
      if (ws) {
        const groupSla = ws.raterulegroups?.[0]?.sla;
        return {
          id: ws.id,
          pickup_workflow_id: ws.pickup_workflow_id ?? null,
          delivery_workflow_id: ws.delivery_workflow_id ?? null,
          workflowOverrides: readMoveWorkflowOverrides(ws.config),
          sla: groupSla ? { id: groupSla.id, duration_hrs: groupSla.duration_hrs ?? null } : null
        };
      }
    } catch {
    }
  }
  return FALLBACK_WORKFLOWSET;
}
async function resolveLaneForMove(laneId, executor, leg = "primary") {
  const lane = await getLaneById({ id: laneId }, { executor }).catch((error) => {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.LANE_NOT_READY,
      `The ${leg} lane ${laneId} could not be read to check its route.`,
      { lane_id: laneId, leg, reason: "lookup_failed" },
      { cause: error }
    );
  });
  if (!lane) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `The ${leg} lane ${laneId} does not exist.`,
      { lane_id: laneId, leg, reason: "lane_not_found" }
    );
  }
  const durationSec = lane.duration_sec ?? 0;
  if (durationSec <= 0) {
    const failed = lane.status === "failed";
    throw new RequestVehicleMoveError(
      failed ? RequestVehicleMoveErrorCode.LANE_ENRICHMENT_FAILED : RequestVehicleMoveErrorCode.LANE_NOT_READY,
      failed ? `The ${leg} lane ${laneId} could not be routed (status failed). Fix the address or re-enrich the lane.` : `The ${leg} lane ${laneId} has no route yet (status ${lane.status ?? "unknown"}). Retry once it is ready.`,
      {
        lane_id: laneId,
        leg,
        lane_status: lane.status ?? null,
        ...failed ? {} : { reason: "not_enriched" }
      }
    );
  }
  return {
    durationSec,
    originLocationId: lane.origin_location_id ?? null,
    destinationLocationId: lane.destination_location_id ?? null
  };
}
async function resolveStandardSla(workflowset, executor) {
  if (workflowset.sla) return workflowset.sla;
  try {
    const slas = await getSlaByName({ name: DEFAULT_SLA_NAME }, { executor });
    const sla = slas?.[0];
    if (sla) return { id: sla.id, duration_hrs: sla.duration_hrs ?? null };
  } catch {
  }
  return FALLBACK_DEFAULT_SLA;
}
function computeStandardDeliverBy(readyByIso, slaDurationHrs) {
  const hrs = slaDurationHrs || 48;
  return new Date(new Date(readyByIso).getTime() + hrs * 60 * 60 * 1e3).toISOString();
}
var CONCIERGE_RETURN_MIN_LANE_DURATION_SEC = 5400;
function computeConciergeDeliverBy(readyByIso, slaDurationHrs, laneDurationSec, isReturn = false) {
  const baseMs = new Date(readyByIso).getTime();
  const hrs = slaDurationHrs || 1;
  const effectiveLaneSec = isReturn && laneDurationSec < CONCIERGE_RETURN_MIN_LANE_DURATION_SEC ? CONCIERGE_RETURN_MIN_LANE_DURATION_SEC : laneDurationSec;
  const deliverByMs = baseMs + hrs * 60 * 60 * 1e3 + effectiveLaneSec * 1e3;
  return new Date(deliverByMs).toISOString();
}

// src/features/create-move/region-gate.ts
import { getCustomerConfig as getCustomerConfig2 } from "@hopdrive/sdk-configs";

// src/features/create-move/gql/getLaneRegionStatus.query.generated.ts
import { resolveExecutor as resolveExecutor12 } from "@hopdrive/sdk-core";
var GetLaneRegionStatusDocument = { "__text": "query GetLaneRegionStatus($id: bigint!) {\n  lanes_by_pk(id: $id) {\n    id\n    pickup {\n      id\n      latitude\n      longitude\n      region {\n        id\n        status\n      }\n    }\n    delivery {\n      id\n      latitude\n      longitude\n      region {\n        id\n        status\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetLaneRegionStatus" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "lanes_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] } }] };
async function getLaneRegionStatus(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor12(executor).query(
    GetLaneRegionStatusDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.lanes_by_pk;
}

// src/features/create-move/gql/getServiceOrigin.query.generated.ts
import { resolveExecutor as resolveExecutor13 } from "@hopdrive/sdk-core";
var GetServiceOriginDocument = { "__text": "query GetServiceOrigin($customerId: bigint!) {\n  customers_by_pk(id: $customerId) {\n    id\n    location {\n      id\n      latitude\n      longitude\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetServiceOrigin" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }] } }] } }] };
async function getServiceOrigin(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor13(executor).query(
    GetServiceOriginDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.customers_by_pk;
}

// src/features/create-move/location-rule.ts
import { calculateDistanceMeters, metersToMiles } from "@hopdrive/sdk-core";
var LIVE_REGION_STATUS = "live";
var SERVICE_RADIUS_GRACE_MILES = 1;
var ALLOWED = { allowed: true };
function isMeasurable(coordinates) {
  return !!coordinates && Number.isFinite(coordinates.latitude) && Number.isFinite(coordinates.longitude);
}
function regionVerdict(pickup, delivery) {
  if (pickup.regionStatus === LIVE_REGION_STATUS || delivery.regionStatus === LIVE_REGION_STATUS) {
    return ALLOWED;
  }
  return {
    allowed: false,
    rule: "region",
    pickupStatus: pickup.regionStatus,
    deliveryStatus: delivery.regionStatus
  };
}
function milesFromOrigin(origin, end) {
  if (!isMeasurable(end.coordinates)) return null;
  return metersToMiles(
    calculateDistanceMeters(
      origin.latitude,
      origin.longitude,
      end.coordinates.latitude,
      end.coordinates.longitude
    )
  );
}
function radiusVerdict(pickup, delivery, origin, radiusMiles) {
  if (typeof radiusMiles !== "number" || !(radiusMiles > 0)) return ALLOWED;
  const from = origin?.coordinates;
  if (!isMeasurable(from)) return ALLOWED;
  const pickupMiles = milesFromOrigin(from, pickup);
  const deliveryMiles = milesFromOrigin(from, delivery);
  if (pickupMiles === null || deliveryMiles === null) return ALLOWED;
  const limit = radiusMiles + SERVICE_RADIUS_GRACE_MILES;
  if (pickupMiles <= limit || deliveryMiles <= limit) return ALLOWED;
  return { allowed: false, rule: "radius", radiusMiles, pickupMiles, deliveryMiles };
}
function evaluateMoveLocations(locations) {
  const { lite, pickup, delivery, origin, radiusMiles } = locations;
  return lite ? radiusVerdict(pickup, delivery, origin, radiusMiles) : regionVerdict(pickup, delivery);
}

// src/features/create-move/region-gate.ts
var UNKNOWN_END = { regionStatus: null, coordinates: null };
var UNREADABLE = { readable: false, pickup: UNKNOWN_END, delivery: UNKNOWN_END };
function coordinate(value) {
  if (value === null || value === void 0 || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
function coordinatesOf(row) {
  const latitude = coordinate(row?.latitude);
  const longitude = coordinate(row?.longitude);
  return latitude === null || longitude === null ? null : { latitude, longitude };
}
function endOf(row) {
  return { regionStatus: row?.region?.status ?? null, coordinates: coordinatesOf(row) };
}
async function readPrimaryLaneRegions(laneId, executor, logger) {
  try {
    const lane = await getLaneRegionStatus({ id: laneId }, { executor });
    if (!lane) return UNREADABLE;
    return { readable: true, pickup: endOf(lane.pickup), delivery: endOf(lane.delivery) };
  } catch (err) {
    safeLog("warn", "move_creation.region_gate_blind", () => ({
      event: "move_creation.region_gate_blind",
      feature: "move-creation",
      boundary: "requestVehicleMove",
      lane_id: laneId,
      error_name: errorName(err)
    }), logger);
    return UNREADABLE;
  }
}
function logServiceOriginBlind(customerId, err, logger) {
  safeLog("warn", "move_creation.service_origin_blind", () => ({
    event: "move_creation.service_origin_blind",
    feature: "move-creation",
    boundary: "requestVehicleMove",
    customer_id: customerId,
    error_name: errorName(err)
  }), logger);
}
async function readServiceOrigin(params) {
  const { customerId, executor, logger } = params;
  try {
    const [customer, config] = await Promise.all([
      getServiceOrigin({ customerId }, { executor }),
      getCustomerConfig2({ customerId, executor })
    ]);
    if (!customer) {
      logServiceOriginBlind(customerId, null, logger);
      return { readable: false };
    }
    const radius = config?.customer_serviceable_radius_miles;
    return {
      readable: true,
      origin: { coordinates: coordinatesOf(customer.location) },
      radiusMiles: typeof radius === "number" ? radius : null
    };
  } catch (err) {
    logServiceOriginBlind(customerId, err, logger);
    return { readable: false };
  }
}
function refusalFor(verdict, laneId) {
  if (verdict.rule === "region") {
    return new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.OUTSIDE_REGION,
      `Lane ${laneId} has no end in a live service region (pickup: ${verdict.pickupStatus ?? "none"}, delivery: ${verdict.deliveryStatus ?? "none"}). At least one location must be within a HopDrive service region.`,
      {
        lane_id: laneId,
        pickup_region_status: verdict.pickupStatus,
        delivery_region_status: verdict.deliveryStatus
      }
    );
  }
  const radius = Math.round(verdict.radiusMiles);
  const pickup = Math.round(verdict.pickupMiles);
  const delivery = Math.round(verdict.deliveryMiles);
  return new RequestVehicleMoveError(
    RequestVehicleMoveErrorCode.OUTSIDE_SERVICE_RADIUS,
    `Both the pickup and delivery locations are outside your ${radius}-mile service radius: the pickup is ${pickup} miles and the delivery is ${delivery} miles from your rooftop. Choose a location within your service radius, or contact HopDrive to change it.`,
    { lane_id: laneId, radius_miles: radius, pickup_miles: pickup, delivery_miles: delivery }
  );
}
function assertMoveLocationsAllowed(laneId, facts) {
  const { lite, lane, serviceOrigin } = facts;
  if (!lane.readable) return;
  if (lite && !serviceOrigin?.readable) return;
  const verdict = evaluateMoveLocations({
    lite,
    pickup: lane.pickup,
    delivery: lane.delivery,
    origin: serviceOrigin?.readable ? serviceOrigin.origin : null,
    radiusMiles: serviceOrigin?.readable ? serviceOrigin.radiusMiles : null
  });
  if ("rule" in verdict) throw refusalFor(verdict, laneId);
}

// src/features/create-move/request-resolution.ts
function validateExplicitEarliestAvailable(value, readyBy, leg) {
  const supplied = new Date(value);
  if (Number.isNaN(supplied.getTime())) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `earliest_available_time on the ${leg} leg is not a parseable timestamp: "${value}".`,
      { leg, earliest_available_time: value }
    );
  }
  const requested = new Date(readyBy);
  if (!Number.isNaN(requested.getTime()) && supplied.getTime() < requested.getTime()) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `earliest_available_time on the ${leg} leg is earlier than its ready_by. The column records when a closed location pushes a move out, so it never precedes the requested time.`,
      { leg, earliest_available_time: value, ready_by: readyBy }
    );
  }
  return supplied.toISOString();
}
async function resolveLegEarliestAvailable(params) {
  const { explicit, readyBy, lane, leg, executor } = params;
  if (explicit !== void 0) return validateExplicitEarliestAvailable(explicit, readyBy, leg);
  if (!lane) return null;
  return resolveEarliestAvailableTime({
    originLocationId: lane.originLocationId,
    destinationLocationId: lane.destinationLocationId,
    readyBy,
    durationSec: lane.durationSec,
    executor
  });
}
function normalizeLoanerLeg(input) {
  const flattened = ["loanerLaneId", "loanerVehicle", "loanerReadyBy"].filter((k) => input[k] !== void 0);
  if (input.loanerLeg !== void 0) {
    if (flattened.length > 0) {
      throw new RequestVehicleMoveError(
        RequestVehicleMoveErrorCode.INVALID_INPUT,
        "loanerLeg and the flattened loanerLaneId / loanerVehicle / loanerReadyBy inputs are two spellings of one leg. Send one or the other.",
        { usecase_key: input.usecase_key, unexpected: flattened }
      );
    }
    return input.loanerLeg;
  }
  if (input.loanerLaneId === void 0) return void 0;
  return {
    lane_id: input.loanerLaneId,
    vehicle: input.loanerVehicle,
    ready_by: input.loanerReadyBy
  };
}
var NO_LANE = Promise.resolve(null);
function settle(read) {
  return read.then(
    (lane) => ({ lane }),
    (error) => ({ error })
  );
}
function unwrap(read) {
  if (read === null) return null;
  if ("error" in read) throw read.error;
  return read.lane;
}
async function resolveRequestContext(params) {
  const { input, now, user, executor, logger } = params;
  const isConcierge = CONCIERGE_USE_CASES.has(input.usecase_key);
  const lite = isLiteProduct(input.product_key);
  const loanerLeg = normalizeLoanerLeg(input);
  const workflowsetRequests = {
    primary: { id: input.workflowset_id, moveTime: input.ready_by },
    loaner: loanerLeg ? {
      id: loanerLeg.workflowset_id ?? input.workflowset_id,
      moveTime: loanerLeg.ready_by ?? input.ready_by
    } : null,
    return: input.returnLeg ? {
      id: input.returnLeg.workflowset_id ?? input.workflowset_id,
      moveTime: input.returnLeg.ready_by ?? input.ready_by
    } : null
  };
  const workflowsetCache = /* @__PURE__ */ new Map();
  const workflowsetFor = (req) => {
    const key = `${req.id ?? ""}@${req.moveTime}`;
    let pending = workflowsetCache.get(key);
    if (!pending) {
      pending = resolveWorkflowset({
        inputWorkflowsetId: req.id,
        customerId: input.customer_id,
        moveTime: req.moveTime,
        executor
      });
      workflowsetCache.set(key, pending);
    }
    return pending;
  };
  const [
    conciergeSla,
    primaryWorkflowset,
    loanerWorkflowset,
    returnWorkflowset,
    primaryLaneRead,
    loanerLaneRead,
    returnLaneRead,
    rideLaneRead,
    primaryLaneRegions,
    serviceOrigin
  ] = await Promise.all([
    // Only the concierge branch uses this, but running it alongside the others
    // costs one parallel round trip and keeps the resolution shape flat.
    isConcierge ? resolveConciergeSla(executor) : Promise.resolve(null),
    workflowsetFor(workflowsetRequests.primary),
    workflowsetRequests.loaner ? workflowsetFor(workflowsetRequests.loaner) : Promise.resolve(null),
    workflowsetRequests.return ? workflowsetFor(workflowsetRequests.return) : Promise.resolve(null),
    // Each lane refuses a request it cannot time (#3447). The refusal is
    // held until the location gate below has spoken, so a lane that is
    // both out of region and still being routed is refused for the
    // permanent reason.
    settle(resolveLaneForMove(input.lane_id, executor, "primary")),
    loanerLeg ? settle(resolveLaneForMove(loanerLeg.lane_id, executor, "loaner")) : NO_LANE,
    input.returnLeg ? settle(resolveLaneForMove(input.returnLeg.lane_id, executor, "return")) : NO_LANE,
    // Checked because dispatch's driver pool sums every leg's lane duration,
    // the ride's included, so a ride on an unrouted lane would be wrong. Its
    // duration also times a ride that runs before the drive (see
    // `rideLaneDurationSec`).
    input.includeRide === true && input.rideLaneId !== void 0 ? settle(resolveLaneForMove(input.rideLaneId, executor, "ride")) : NO_LANE,
    // The location gate's reads. Neither rejects, so a lookup cannot take
    // this Promise.all down. The rooftop and its radius matter only to Lite.
    readPrimaryLaneRegions(input.lane_id, executor, logger),
    lite ? readServiceOrigin({ customerId: input.customer_id, executor, logger }) : Promise.resolve(null)
  ]);
  assertMoveLocationsAllowed(input.lane_id, {
    lite,
    lane: primaryLaneRegions,
    serviceOrigin
  });
  const primaryLane = unwrap(primaryLaneRead);
  const loanerLane = unwrap(loanerLaneRead);
  const returnLane = unwrap(returnLaneRead);
  const rideLane = unwrap(rideLaneRead);
  const [primaryEarliestAvailable, loanerEarliestAvailable, returnEarliestAvailable] = await Promise.all([
    resolveLegEarliestAvailable({
      explicit: input.earliest_available_time,
      readyBy: input.ready_by,
      lane: primaryLane,
      leg: "primary",
      executor
    }),
    loanerLeg ? resolveLegEarliestAvailable({
      explicit: loanerLeg.earliest_available_time ?? input.earliest_available_time,
      readyBy: loanerLeg.ready_by ?? input.ready_by,
      lane: loanerLane,
      leg: "loaner",
      executor
    }) : Promise.resolve(null),
    input.returnLeg ? resolveLegEarliestAvailable({
      explicit: input.returnLeg.earliest_available_time ?? input.earliest_available_time,
      readyBy: input.returnLeg.ready_by ?? input.ready_by,
      lane: returnLane,
      leg: "return",
      executor
    }) : Promise.resolve(null)
  ]);
  const slaCache = /* @__PURE__ */ new Map();
  const slaFor = (ws) => {
    if (conciergeSla) return Promise.resolve(conciergeSla);
    let pending = slaCache.get(ws);
    if (!pending) {
      pending = resolveStandardSla(ws, executor);
      slaCache.set(ws, pending);
    }
    return pending;
  };
  const [primarySla, loanerSla, returnSla] = await Promise.all([
    slaFor(primaryWorkflowset),
    loanerWorkflowset ? slaFor(loanerWorkflowset) : Promise.resolve(null),
    returnWorkflowset ? slaFor(returnWorkflowset) : Promise.resolve(null)
  ]);
  const primaryDefaults = { workflowset: primaryWorkflowset, sla: primarySla };
  const ctx = {
    now,
    user,
    primaryDefaults,
    loanerDefaults: loanerWorkflowset && loanerSla ? { workflowset: loanerWorkflowset, sla: loanerSla } : primaryDefaults,
    returnDefaults: returnWorkflowset && returnSla ? { workflowset: returnWorkflowset, sla: returnSla } : primaryDefaults,
    loanerLeg,
    primaryLaneDurationSec: primaryLane.durationSec,
    loanerLaneDurationSec: loanerLane?.durationSec ?? 0,
    returnLaneDurationSec: returnLane?.durationSec ?? 0,
    rideLaneDurationSec: rideLane?.durationSec ?? 0,
    primaryEarliestAvailable,
    loanerEarliestAvailable,
    returnEarliestAvailable
  };
  return ctx;
}

// src/features/create-move/contract.ts
var MoveRole = {
  /** The customer's own vehicle. Always the primary move. */
  CUSTOMER_DRIVE: "customer-drive",
  /** A dealer-provided loaner, moving opposite the customer vehicle. */
  LOANER_DRIVE: "loaner-drive",
  /** A rideshare or shuttle leg carrying a driver, not a vehicle. */
  RIDE: "ride"
};

// src/features/create-move/move-defaults.ts
var COMMON_MOVE_DEFAULTS = {
  active: 1,
  auto_assign: 0,
  priority: 10,
  payable: true,
  pinnable: false,
  disputed: false,
  lyft_flag: 0,
  manual_flag: false
};
var CUSTOMER_ROLE_DEFAULTS = {
  class: "stranded",
  chargeable: true,
  consumer_pickup: true,
  consumer_type: ConsumerType.CUSTOMER
};
var LOANER_ROLE_DEFAULTS = {
  class: "stranded",
  chargeable: false,
  consumer_pickup: true,
  consumer_type: ConsumerType.LOANER
};
var ONE_WAY_ROLE_DEFAULTS = {
  class: "stranded",
  chargeable: true,
  consumer_pickup: false,
  consumer_at_pickup: 0
};
var ROUND_TRIP_ROLE_DEFAULTS = {
  class: "base",
  chargeable: true,
  consumer_pickup: false,
  consumer_at_pickup: 0
};
function consumerAtPickup(role, isReturn) {
  if (role === "customer") return isReturn ? 0 : 1;
  return isReturn ? 1 : 0;
}

// src/features/create-move/move-rows.ts
function moveRoleOf(move) {
  if (move.move_type === MoveType.RIDE) return MoveRole.RIDE;
  return move.consumer_type === ConsumerType.LOANER ? MoveRole.LOANER_DRIVE : MoveRole.CUSTOMER_DRIVE;
}
function toRequestedMove(link) {
  const { move } = link;
  return {
    id: move.id,
    role: moveRoleOf(move),
    cardinality: link.cardinality,
    move_type: move.move_type,
    consumer_type: move.consumer_type,
    lane_id: move.lane_id,
    status: move.status,
    usecase_key: move.usecase_key,
    ready_by: move.ready_by,
    deliver_by: move.deliver_by,
    vehicle_vin: move.vehicle_vin,
    reference_num: move.reference_num,
    consumer_name: move.consumer_name,
    consumer_phone: move.consumer_phone,
    parent_move_id: move.parent_move_id ?? null
  };
}
function splitLegs(scenarioId, links) {
  const legs = [...links].sort((a, b) => a.cardinality - b.cardinality).map(toRequestedMove);
  const move = legs.find((m) => m.role === MoveRole.CUSTOMER_DRIVE);
  if (!move) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.SCENARIO_INCOMPLETE,
      `Scenario ${scenarioId} has no customer drive move (${legs.length} legs linked).`,
      { scenario_id: scenarioId, legs: legs.length }
    );
  }
  return { move, peerMoves: legs.filter((m) => m.id !== move.id) };
}
function vehicleColumns(vehicle) {
  const v = vehicle ?? {};
  return {
    vehicle_vin: v.vin,
    vehicle_make: v.make,
    vehicle_model: v.model,
    vehicle_year: v.year,
    vehicle_color: v.color,
    vehicle_stock: v.stock,
    // `moves.vehicle_odometer` is a text column but the Action declares
    // `odometer: Float`, so Hasura would reject the number. Coerced here
    // because widening it to a string would change the Action's public input.
    vehicle_odometer: v.odometer == null ? void 0 : String(v.odometer),
    // Conditional because both columns mean something when the caller says
    // nothing. An undefined would clobber the `false` default for
    // `manual_flag` in COMMON_MOVE_DEFAULTS, and a null gross weight says
    // something the request did not.
    ...v.manual !== void 0 ? { manual_flag: v.manual } : {},
    ...v.gross_weight_lbs !== void 0 ? { vehicle_gross_weight_lbs: v.gross_weight_lbs } : {}
  };
}
function workflowDataColumns(leg) {
  return {
    ...leg.pickup_workflow_data !== void 0 ? { pickup_workflow_data: leg.pickup_workflow_data } : {},
    ...leg.delivery_workflow_data !== void 0 ? { delivery_workflow_data: leg.delivery_workflow_data } : {}
  };
}
function earliestAvailableColumn(ctx) {
  return ctx.earliestAvailableTime !== null ? { earliest_available_time: ctx.earliestAvailableTime } : {};
}
function buildCustomerConciergeMove(input, ctx) {
  const readyBy = input.ready_by;
  return {
    ...COMMON_MOVE_DEFAULTS,
    ...CUSTOMER_ROLE_DEFAULTS,
    consumer_at_pickup: consumerAtPickup("customer", ctx.isReturn),
    // Only pickups are pinned by default. A pickup has a committed appointment
    // time the scheduler must not drift, and a return is scheduled against the
    // SLA window instead. `scheduled` adds the other reason to pin.
    pinnable: !ctx.isReturn || input.scheduled === true,
    // The immutable appointment time schedulers anchor to; pickup_time may be
    // repositioned during planning, target_pickup_time never moves. Null on a
    // return, which has no such anchor.
    target_pickup_time: ctx.isReturn ? null : input.ready_by,
    sequence: ctx.sequence,
    rate_class_override: ctx.rateClassOverride,
    move_type: MoveType.DRIVE,
    usecase_key: input.usecase_key,
    customer_id: input.customer_id,
    lane_id: input.lane_id,
    ready_by: readyBy,
    pickup_time: readyBy,
    deliver_by: computeConciergeDeliverBy(
      readyBy,
      ctx.sla.duration_hrs,
      ctx.laneDurationSec,
      ctx.isReturn
    ),
    sla_id: input.sla_id ?? ctx.sla.id,
    workflowset_id: ctx.workflowset.id,
    ...effectiveWorkflows(ctx.workflowset, MoveWorkflowRole.VALET_CUSTOMER),
    consumer_name: input.consumer_name,
    consumer_phone: input.consumer_phone,
    reference_num: input.reference_num,
    dealer_contact: input.dealer_contact,
    payer_id: input.payer_id,
    move_details: input.move_details,
    config: input.config,
    ...vehicleColumns(input.vehicle),
    ...workflowDataColumns(input),
    ...earliestAvailableColumn(ctx),
    createdat: ctx.now,
    updatedat: ctx.now,
    createdBy: ctx.user,
    updatedBy: ctx.user
  };
}
function buildLoanerMove(input, leg, ctx) {
  const readyBy = leg.ready_by ?? input.ready_by;
  return {
    ...COMMON_MOVE_DEFAULTS,
    ...LOANER_ROLE_DEFAULTS,
    consumer_at_pickup: consumerAtPickup("loaner", ctx.isReturn),
    // Pinned alongside the customer leg, and only for pickups, so the pair
    // stays together. `scheduled` pins both for the same reason.
    pinnable: !ctx.isReturn || input.scheduled === true,
    // Same target as the customer leg, the appointment time rather than the
    // loaner's own ready-by. Schedulers derive the loaner position from it
    // (target minus lane duration).
    target_pickup_time: ctx.isReturn ? null : input.ready_by,
    sequence: ctx.sequence,
    rate_class_override: ctx.rateClassOverride,
    move_type: MoveType.DRIVE,
    usecase_key: input.usecase_key,
    customer_id: input.customer_id,
    lane_id: leg.lane_id,
    ready_by: readyBy,
    pickup_time: readyBy,
    deliver_by: computeConciergeDeliverBy(
      readyBy,
      ctx.sla.duration_hrs,
      ctx.laneDurationSec,
      ctx.isReturn
    ),
    sla_id: leg.sla_id ?? input.sla_id ?? ctx.sla.id,
    workflowset_id: ctx.workflowset.id,
    ...effectiveWorkflows(ctx.workflowset, MoveWorkflowRole.VALET_LOANER),
    consumer_name: input.consumer_name,
    consumer_phone: input.consumer_phone,
    reference_num: leg.reference_num ?? input.reference_num,
    dealer_contact: leg.dealer_contact ?? input.dealer_contact,
    payer_id: input.payer_id,
    // No fallback to the top-level notes, unlike the customer leg. Notes aimed
    // at the customer's own car are the wrong instruction on the loaner.
    move_details: leg.move_details,
    config: leg.config ?? input.config,
    ...vehicleColumns(leg.vehicle),
    ...workflowDataColumns(leg),
    ...earliestAvailableColumn(ctx),
    createdat: ctx.now,
    updatedat: ctx.now,
    createdBy: ctx.user,
    updatedBy: ctx.user
  };
}
function buildRideMove(input, now, user, rideLaneId, sequence, options = {}) {
  return {
    ...COMMON_MOVE_DEFAULTS,
    sequence,
    move_type: MoveType.RIDE,
    customer_id: input.customer_id,
    lane_id: rideLaneId,
    ready_by: input.ready_by,
    // Every blueprint passes one; the guard keeps a caller without a time from
    // writing an empty string.
    ...options.pickupTime ? { pickup_time: options.pickupTime } : {},
    ride_type: RideType.AUTO,
    config: input.config,
    createdat: now,
    updatedat: now,
    createdBy: user,
    updatedBy: user
  };
}
function buildLink(cardinality, now, user, moveData) {
  return {
    cardinality,
    createdat: now,
    updatedat: now,
    createdby: user,
    updatedby: user,
    move: { data: moveData }
  };
}
function buildOneWayMove(input, ctx) {
  const readyBy = input.ready_by;
  return {
    ...COMMON_MOVE_DEFAULTS,
    ...ONE_WAY_ROLE_DEFAULTS,
    pinnable: input.scheduled === true,
    sequence: ctx.sequence,
    rate_class_override: ctx.rateClassOverride,
    move_type: MoveType.DRIVE,
    usecase_key: input.usecase_key,
    customer_id: input.customer_id,
    lane_id: input.lane_id,
    ready_by: readyBy,
    pickup_time: readyBy,
    // No lane duration and a 48-hour fallback, unlike concierge. A one-way is a
    // delivery window, not an appointment.
    deliver_by: computeStandardDeliverBy(readyBy, ctx.sla.duration_hrs),
    sla_id: input.sla_id ?? ctx.sla.id,
    workflowset_id: ctx.workflowset.id,
    ...effectiveWorkflows(ctx.workflowset, MoveWorkflowRole.OPERATIONAL),
    reference_num: input.reference_num,
    dealer_contact: input.dealer_contact,
    payer_id: input.payer_id,
    move_details: input.move_details,
    config: input.config,
    ...vehicleColumns(input.vehicle),
    ...workflowDataColumns(input),
    ...earliestAvailableColumn(ctx),
    createdat: ctx.now,
    updatedat: ctx.now,
    createdBy: ctx.user,
    updatedBy: ctx.user
  };
}
function buildRoundTripLeg(input, leg, ctx) {
  const readyBy = leg.ready_by ?? input.ready_by;
  return {
    ...COMMON_MOVE_DEFAULTS,
    ...ROUND_TRIP_ROLE_DEFAULTS,
    // Nothing pins by default. A round-trip is a delivery window, not an
    // appointment, so there is no committed time for the scheduler to drift
    // off. `scheduled` supplies one, on both legs.
    pinnable: input.scheduled === true,
    sequence: ctx.sequence,
    rate_class_override: ctx.rateClassOverride,
    move_type: MoveType.DRIVE,
    usecase_key: input.usecase_key,
    customer_id: input.customer_id,
    lane_id: leg.lane_id,
    ready_by: readyBy,
    pickup_time: readyBy,
    // Computed like `one-way`, from SLA hours off the requested time with a
    // 48-hour fallback, no lane duration and no 90-minute floor.
    deliver_by: computeStandardDeliverBy(readyBy, ctx.sla.duration_hrs),
    sla_id: leg.sla_id ?? input.sla_id ?? ctx.sla.id,
    workflowset_id: ctx.workflowset.id,
    ...effectiveWorkflows(ctx.workflowset, MoveWorkflowRole.OPERATIONAL),
    reference_num: leg.reference_num ?? input.reference_num,
    dealer_contact: leg.dealer_contact ?? input.dealer_contact,
    move_details: leg.move_details ?? input.move_details,
    payer_id: input.payer_id,
    config: leg.config ?? input.config,
    ...vehicleColumns(leg.vehicle),
    ...workflowDataColumns(leg),
    ...earliestAvailableColumn(ctx),
    createdat: ctx.now,
    updatedat: ctx.now,
    createdBy: ctx.user,
    updatedBy: ctx.user
  };
}

// src/features/create-move/scenario-blueprints.ts
function projectLiteOntoLegs(links, productKey) {
  const lite = isLiteProduct(productKey);
  return links.map((link) => ({
    ...link,
    move: { data: { ...link.move.data, lite, ...lite ? { payable: false } : {} } }
  }));
}
function buildConciergeBlueprint(input, ctx) {
  const isReturn = RETURN_USE_CASES.has(input.usecase_key);
  const includeRide = input.includeRide === true;
  if (includeRide && input.rideLaneId === void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      "includeRide=true requires rideLaneId (the inverse lane).",
      { usecase_key: input.usecase_key, missing: "rideLaneId" }
    );
  }
  if (input.loanerLaneId !== void 0 || input.loanerVehicle !== void 0 || input.loanerLeg !== void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `loanerLaneId / loanerVehicle / loanerLeg are not applicable to "${input.usecase_key}". Use "${isReturn ? UseCaseKey.CONCIERGE_LOANER_RETURN : UseCaseKey.CONCIERGE_LOANER_PICKUP}".`,
      {
        usecase_key: input.usecase_key,
        unexpected: ["loanerLaneId", "loanerVehicle", "loanerLeg"]
      }
    );
  }
  assertNoReturnLeg(input);
  const driveMove = buildCustomerConciergeMove(input, {
    now: ctx.now,
    user: ctx.user,
    ...ctx.primaryDefaults,
    laneDurationSec: ctx.primaryLaneDurationSec,
    earliestAvailableTime: ctx.primaryEarliestAvailable,
    // `sequence` is 1-based and follows the physical order, so the drive is 2
    // on a pickup with a ride (the ride runs first) and 1 everywhere else.
    sequence: includeRide && !isReturn ? 2 : 1,
    rateClassOverride: 0,
    isReturn
  });
  if (!includeRide) {
    return {
      scenarioKey: isReturn ? ScenarioKey.CONCIERGE_RETURN_NO_RIDESHARE : ScenarioKey.CONCIERGE_PICKUP_NO_RIDESHARE,
      links: [buildLink(0, ctx.now, ctx.user, driveMove)]
    };
  }
  const rideSequence = isReturn ? 2 : 1;
  const readyByMs = new Date(input.ready_by).getTime();
  const ridePickupMs = isReturn ? readyByMs + ctx.primaryLaneDurationSec * 1e3 : readyByMs - ctx.rideLaneDurationSec * 1e3;
  const rideMove = buildRideMove(input, ctx.now, ctx.user, input.rideLaneId, rideSequence, {
    pickupTime: new Date(ridePickupMs).toISOString()
  });
  return {
    scenarioKey: isReturn ? ScenarioKey.CONCIERGE_RETURN : ScenarioKey.CONCIERGE_PICKUP,
    links: isReturn ? [buildLink(0, ctx.now, ctx.user, driveMove), buildLink(1, ctx.now, ctx.user, rideMove)] : [buildLink(0, ctx.now, ctx.user, rideMove), buildLink(1, ctx.now, ctx.user, driveMove)]
  };
}
function buildConciergeLoanerBlueprint(input, ctx) {
  const isReturn = RETURN_USE_CASES.has(input.usecase_key);
  const loanerLeg = ctx.loanerLeg;
  if (loanerLeg === void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `usecase_key="${input.usecase_key}" requires loanerLaneId (the loaner's lane, the inverse of lane_id), or a loanerLeg carrying it.`,
      { usecase_key: input.usecase_key, missing: "loanerLaneId" }
    );
  }
  if (input.includeRide === true || input.rideLaneId !== void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `includeRide / rideLaneId are not applicable to "${input.usecase_key}": the loaner leg already moves the driver.`,
      { usecase_key: input.usecase_key, unexpected: ["includeRide", "rideLaneId"] }
    );
  }
  assertNoReturnLeg(input);
  const shared = { now: ctx.now, user: ctx.user };
  const loanerAt = isReturn ? 1 : 0;
  const customerAt = isReturn ? 0 : 1;
  const loanerMove = buildLoanerMove(input, loanerLeg, {
    ...shared,
    ...ctx.loanerDefaults,
    laneDurationSec: ctx.loanerLaneDurationSec,
    earliestAvailableTime: ctx.loanerEarliestAvailable,
    sequence: loanerAt + 1,
    rateClassOverride: 1,
    isReturn
  });
  const customerMove = buildCustomerConciergeMove(input, {
    ...shared,
    ...ctx.primaryDefaults,
    laneDurationSec: ctx.primaryLaneDurationSec,
    earliestAvailableTime: ctx.primaryEarliestAvailable,
    sequence: customerAt + 1,
    rateClassOverride: 1,
    isReturn
  });
  const links = [];
  links[loanerAt] = buildLink(loanerAt, ctx.now, ctx.user, loanerMove);
  links[customerAt] = buildLink(customerAt, ctx.now, ctx.user, customerMove);
  return {
    scenarioKey: isReturn ? ScenarioKey.CONCIERGE_LOANER_RETURN : ScenarioKey.CONCIERGE_LOANER_PICKUP,
    links
  };
}
function buildOneWayBlueprint(input, ctx) {
  if (input.includeRide === void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `usecase_key="one-way" requires an explicit includeRide. The legacy path always created a return ride, so omitting it would either hide that policy or silently change it. Pass includeRide: true with a rideLaneId to keep today's behaviour.`,
      { usecase_key: input.usecase_key, missing: "includeRide" }
    );
  }
  if (input.includeRide && input.rideLaneId === void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      "includeRide=true requires rideLaneId (the inverse lane).",
      { usecase_key: input.usecase_key, missing: "rideLaneId" }
    );
  }
  if (input.loanerLaneId !== void 0 || input.loanerVehicle !== void 0 || input.loanerLeg !== void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      'loanerLaneId / loanerVehicle / loanerLeg are not applicable to "one-way".',
      {
        usecase_key: input.usecase_key,
        unexpected: ["loanerLaneId", "loanerVehicle", "loanerLeg"]
      }
    );
  }
  assertNoReturnLeg(input);
  const driveMove = buildOneWayMove(input, {
    now: ctx.now,
    user: ctx.user,
    ...ctx.primaryDefaults,
    laneDurationSec: ctx.primaryLaneDurationSec,
    earliestAvailableTime: ctx.primaryEarliestAvailable,
    sequence: 1,
    rateClassOverride: 0,
    isReturn: false
  });
  if (!input.includeRide) {
    return {
      scenarioKey: ScenarioKey.STRANDED_NO_RIDESHARE,
      links: [buildLink(0, ctx.now, ctx.user, driveMove)]
    };
  }
  return {
    scenarioKey: ScenarioKey.STRANDED_RIDESHARE_AFTER,
    links: [
      buildLink(0, ctx.now, ctx.user, driveMove),
      buildLink(
        1,
        ctx.now,
        ctx.user,
        buildRideMove(input, ctx.now, ctx.user, input.rideLaneId, 2, {
          // The ride starts when the drive ends, so the DRIVE lane times it,
          // the same time `createRide` in @hopdrive/sdk-dispatch computes for a
          // RIDE_POSITION.AFTER. Only a ride before its drive uses its own lane.
          pickupTime: new Date(
            new Date(input.ready_by).getTime() + ctx.primaryLaneDurationSec * 1e3
          ).toISOString()
        })
      )
    ]
  };
}
function assertNoReturnLeg(input) {
  if (input.returnLeg === void 0) return;
  throw new RequestVehicleMoveError(
    RequestVehicleMoveErrorCode.INVALID_INPUT,
    `returnLeg is not applicable to "${input.usecase_key}". Only "${UseCaseKey.ROUND_TRIP}" has a second customer leg.`,
    { usecase_key: input.usecase_key, unexpected: ["returnLeg"] }
  );
}
function buildRoundTripBlueprint(input, ctx) {
  if (input.returnLeg === void 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      `usecase_key="${UseCaseKey.ROUND_TRIP}" requires returnLeg, carrying at least the inverse lane id. A round trip with one leg is a one-way.`,
      { usecase_key: input.usecase_key, missing: "returnLeg" }
    );
  }
  const unexpected = [
    "includeRide",
    "rideLaneId",
    "loanerLaneId",
    "loanerVehicle",
    "loanerReadyBy",
    "loanerLeg"
  ].filter((k) => input[k] !== void 0);
  if (unexpected.length > 0) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.INVALID_INPUT,
      "A round trip creates no ride and has no loaner: the return vehicle is how the driver gets back. Pass neither includeRide/rideLaneId nor any loaner input.",
      { usecase_key: input.usecase_key, unexpected }
    );
  }
  const shared = { now: ctx.now, user: ctx.user };
  const forward = buildRoundTripLeg(
    input,
    {
      lane_id: input.lane_id,
      vehicle: input.vehicle,
      ready_by: input.ready_by,
      reference_num: input.reference_num,
      dealer_contact: input.dealer_contact,
      move_details: input.move_details,
      config: input.config,
      workflowset_id: input.workflowset_id,
      sla_id: input.sla_id,
      pickup_workflow_data: input.pickup_workflow_data,
      delivery_workflow_data: input.delivery_workflow_data,
      earliest_available_time: input.earliest_available_time
    },
    {
      ...shared,
      ...ctx.primaryDefaults,
      laneDurationSec: ctx.primaryLaneDurationSec,
      earliestAvailableTime: ctx.primaryEarliestAvailable,
      sequence: 1,
      rateClassOverride: 1,
      isReturn: false
    }
  );
  const back = buildRoundTripLeg(input, input.returnLeg, {
    ...shared,
    ...ctx.returnDefaults,
    laneDurationSec: ctx.returnLaneDurationSec,
    earliestAvailableTime: ctx.returnEarliestAvailable,
    sequence: 2,
    rateClassOverride: 1,
    isReturn: false
  });
  return {
    scenarioKey: ScenarioKey.ROUND_TRIP,
    links: [buildLink(0, ctx.now, ctx.user, forward), buildLink(1, ctx.now, ctx.user, back)]
  };
}
function blueprintFor(input, ctx) {
  let blueprint;
  switch (input.usecase_key) {
    case UseCaseKey.CONCIERGE_PICKUP:
    case UseCaseKey.CONCIERGE_RETURN:
      blueprint = buildConciergeBlueprint(input, ctx);
      break;
    case UseCaseKey.CONCIERGE_LOANER_PICKUP:
    case UseCaseKey.CONCIERGE_LOANER_RETURN:
      blueprint = buildConciergeLoanerBlueprint(input, ctx);
      break;
    case UseCaseKey.ONE_WAY:
      blueprint = buildOneWayBlueprint(input, ctx);
      break;
    case UseCaseKey.ROUND_TRIP:
      blueprint = buildRoundTripBlueprint(input, ctx);
      break;
    default: {
      const exhaustive = input.usecase_key;
      throw new RequestVehicleMoveError(
        RequestVehicleMoveErrorCode.UNSUPPORTED_USECASE,
        `Use case "${String(exhaustive)}" is not built yet. Supported: ${SUPPORTED_USE_CASE_KEYS.join(", ")}.`,
        { usecase_key: exhaustive, supported: [...SUPPORTED_USE_CASE_KEYS] }
      );
    }
  }
  return blueprint;
}

// src/features/create-move/contacts.ts
import { resolveExecutor as resolveExecutor15 } from "@hopdrive/sdk-core";

// src/features/create-move/gql/insertMoveContacts.mutation.generated.ts
import { resolveExecutor as resolveExecutor14 } from "@hopdrive/sdk-core";
var InsertMoveContactsDocument = { "__text": "mutation InsertMoveContacts($objects: [contactstomoves_insert_input!]!) {\n  insert_contactstomoves(objects: $objects) {\n    affected_rows\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertMoveContacts" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "objects" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "contactstomoves_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_contactstomoves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "objects" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };

// src/features/create-move/contacts.ts
var CONTACT_FIELD_MAX_LENGTH = {
  name: 255,
  email: 255,
  mobile_number: 20,
  landline_number: 20
};
var DEFAULT_CONTACT_NAME = { pickup: "Pickup Contact", delivery: "Delivery Contact" };
function prepareContacts(contacts) {
  const sides = {};
  const dropped = [];
  for (const side of ["pickup", "delivery"]) {
    const given = contacts?.[side];
    if (!given) continue;
    const fit = (field) => {
      const value = given[field];
      if (typeof value !== "string" || value.trim().length === 0) return null;
      if (value.length > CONTACT_FIELD_MAX_LENGTH[field]) {
        dropped.push({ side, field, reason: "too_long" });
        return null;
      }
      return value;
    };
    const name = fit("name");
    const mobile_number = fit("mobile_number");
    const landline_number = fit("landline_number");
    const email = fit("email");
    if (!name && !mobile_number && !landline_number && !email) {
      dropped.push({ side, field: null, reason: "unreachable" });
      continue;
    }
    const notes = typeof given.notes === "string" && given.notes.trim().length > 0 ? given.notes : null;
    sides[side] = {
      name: name ?? DEFAULT_CONTACT_NAME[side],
      mobile_number,
      landline_number,
      email,
      notes,
      created_by_user_id: given.created_by_user_id ?? null,
      created_by_type: given.created_by_type ?? null
    };
  }
  return { sides, dropped };
}
async function writeContacts(params) {
  const { result, prepared, executor, logger } = params;
  const { dropped } = prepared;
  if (dropped.length > 0) {
    safeLog("warn", "move_creation.contacts_dropped", () => ({
      event: "move_creation.contacts_dropped",
      feature: "move-creation",
      boundary: "requestVehicleMove",
      scenario_id: result.scenario.id,
      dropped
    }), logger);
  }
  const sides = ["pickup", "delivery"].filter((side) => prepared.sides[side]);
  const driveIds = [result.move, ...result.peerMoves].filter((move) => move.move_type === "drive").map((move) => move.id);
  const objects = driveIds.flatMap(
    (moveId) => sides.map((side) => ({
      move_id: moveId,
      contact_type: side,
      is_primary: false,
      contact_notes: null,
      contact: { data: prepared.sides[side] }
    }))
  );
  if (objects.length === 0) return { outcome: "none", dropped };
  try {
    await resolveExecutor15(executor).mutate(InsertMoveContactsDocument, {
      objects
    });
    return { outcome: "saved", dropped };
  } catch (cause) {
    safeLog("error", "move_creation.contacts_failed", () => ({
      event: "move_creation.contacts_failed",
      feature: "move-creation",
      boundary: "requestVehicleMove",
      scenario_id: result.scenario.id,
      error_name: errorName(cause)
    }), logger);
    return { outcome: "failed", dropped };
  }
}

// src/features/create-move/scenario-persistence.ts
import { resolveExecutor as resolveExecutor20 } from "@hopdrive/sdk-core";

// src/features/create-move/gql/createScenarioWithMoves.mutation.generated.ts
import { resolveExecutor as resolveExecutor16 } from "@hopdrive/sdk-core";
var CreateScenarioWithMovesDocument = { "__text": "mutation CreateScenarioWithMoves($scenario: scenarios_insert_input!) {\n  insert_scenarios_one(object: $scenario) {\n    id\n    scenario_key\n    status\n    config\n    product_key\n    usecase_key\n    customer_id\n    moves(order_by: {cardinality: asc}) {\n      cardinality\n      move_id\n      move {\n        id\n        status\n        move_type\n        usecase_key\n        customer_id\n        lane_id\n        parent_move_id\n        ready_by\n        deliver_by\n        pickup_time\n        sla_id\n        workflowset_id\n        pickup_workflow_id\n        delivery_workflow_id\n        class\n        priority\n        active\n        consumer_pickup\n        consumer_at_pickup\n        consumer_type\n        consumer_name\n        consumer_phone\n        reference_num\n        vehicle_vin\n        vehicle_make\n        vehicle_model\n        vehicle_year\n        vehicle_color\n        vehicle_stock\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "CreateScenarioWithMoves" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenario" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "scenarios_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_scenarios_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenario" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cardinality" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sla_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }, { "kind": "Field", "name": { "kind": "Name", "value": "priority" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_stock" } }] } }] } }] } }] } }] };

// src/features/create-move/gql/setMoveParent.mutation.generated.ts
import { resolveExecutor as resolveExecutor17 } from "@hopdrive/sdk-core";
var SetMoveParentDocument = { "__text": 'mutation SetMoveParent($moveId: bigint!, $parentMoveId: bigint!) {\n  update_moves(\n    where: {id: {_eq: $moveId}, parent_move_id: {_is_null: true}}\n    _set: {parent_move_id: $parentMoveId, updatedat: "now()"}\n  ) {\n    returning {\n      id\n      parent_move_id\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "SetMoveParent" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "parentMoveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "parent_move_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "parent_move_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "parentMoveId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }] } }] } }] } }] };

// src/features/create-move/gql/releaseScenario.mutation.generated.ts
import { resolveExecutor as resolveExecutor18 } from "@hopdrive/sdk-core";
var ReleaseScenarioDocument = { "__text": 'mutation ReleaseScenario($scenarioId: bigint!, $user: String!, $now: timestamptz!) {\n  update_scenarios(\n    where: {id: {_eq: $scenarioId}, status: {_eq: "new"}}\n    _set: {status: "pending", updatedby: $user, updatedat: $now}\n  ) {\n    affected_rows\n    returning {\n      id\n      status\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "ReleaseScenario" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "user" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_scenarios" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "new", "block": false } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "pending", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "user" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] };

// src/features/create-move/gql/getScenarioBySource.query.generated.ts
import { resolveExecutor as resolveExecutor19 } from "@hopdrive/sdk-core";
var GetScenarioBySourceDocument = { "__text": "query GetScenarioBySource($customerId: bigint!, $channel: String!, $requestId: String!) {\n  scenarios(\n    where: {customer_id: {_eq: $customerId}, source_channel: {_eq: $channel}, source_request_id: {_eq: $requestId}}\n    limit: 1\n  ) {\n    id\n    scenario_key\n    status\n    product_key\n    usecase_key\n    customer_id\n    moves(order_by: {cardinality: asc}) {\n      cardinality\n      move_id\n      move {\n        id\n        status\n        move_type\n        usecase_key\n        customer_id\n        lane_id\n        parent_move_id\n        ready_by\n        deliver_by\n        pickup_time\n        consumer_type\n        consumer_name\n        consumer_phone\n        reference_num\n        vehicle_vin\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenarioBySource" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "channel" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "requestId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_channel" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "channel" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_request_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "requestId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cardinality" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }] } }] } }] } }] } }] };
async function getScenarioBySource(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor19(executor).query(
    GetScenarioBySourceDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.scenarios;
}

// src/features/create-move/move-lineage.ts
var CREATION_CARDINALITIES = /* @__PURE__ */ new Set([0, 1]);
var USE_CASE_KEYS = new Set(Object.values(UseCaseKey));
function isUseCaseKey(value) {
  return USE_CASE_KEYS.has(value);
}
function lineagePairs(usecaseKey, legs) {
  if (!isUseCaseKey(usecaseKey)) return [];
  switch (usecaseKey) {
    case UseCaseKey.CONCIERGE_PICKUP:
    case UseCaseKey.CONCIERGE_RETURN:
    case UseCaseKey.ONE_WAY:
      return ridesToCustomerDrive(legs);
    case UseCaseKey.CONCIERGE_LOANER_PICKUP:
    case UseCaseKey.CONCIERGE_LOANER_RETURN:
    case UseCaseKey.ROUND_TRIP:
      return secondLegToFirst(legs);
    default: {
      const undecided = usecaseKey;
      void undecided;
      return [];
    }
  }
}
function missingLineage(pairs) {
  return pairs.filter((pair) => pair.child.parent_move_id == null);
}
function ridesToCustomerDrive({ move, peerMoves }) {
  return peerMoves.filter(
    (peer) => peer.role === MoveRole.RIDE && CREATION_CARDINALITIES.has(peer.cardinality) && peer.id !== move.id
  ).map((ride) => ({ child: ride, parentId: move.id }));
}
function secondLegToFirst({ move, peerMoves }) {
  const legs = [move, ...peerMoves];
  const first = legs.filter((leg) => leg.cardinality === 0);
  const second = legs.filter((leg) => leg.cardinality === 1);
  if (first.length !== 1 || second.length !== 1) return [];
  const [parent] = first;
  const [child] = second;
  if (!parent || !child || parent.id === child.id) return [];
  return [{ child, parentId: parent.id }];
}

// src/features/create-move/scenario-persistence.ts
async function insertScenario(params) {
  const { input, blueprint, links, now, user, executor } = params;
  const scenario = {
    scenario_key: blueprint.scenarioKey,
    // Product identity, written in the same statement as the moves. Nothing
    // downstream has to wait for a backfill to know what was bought.
    product_key: input.product_key,
    usecase_key: input.usecase_key,
    // The scenario is the commercial transaction and a transaction has exactly
    // one customer. It also scopes the source idempotency key: without it, two
    // callers numbering their own requests from 1 collide on the same channel
    // and one replays the other's scenario.
    customer_id: input.customer_id,
    source_channel: input.source?.channel ?? null,
    source_request_id: input.source?.request_id ?? null,
    status: ScenarioStatus.NEW,
    config: {},
    createdat: now,
    updatedat: now,
    createdby: user,
    updatedby: user,
    moves: { data: links }
  };
  const requestOptions = {};
  let created;
  try {
    const result = await resolveExecutor20(executor).mutate(
      CreateScenarioWithMovesDocument,
      { scenario },
      requestOptions
    );
    created = result.insert_scenarios_one;
  } catch (cause) {
    const raced = await findExistingBySource(input.customer_id, input.source, executor);
    if (raced) return raced;
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.PERSISTENCE_FAILED,
      "The scenario insert failed.",
      {
        product_key: input.product_key,
        usecase_key: input.usecase_key,
        scenario_key: blueprint.scenarioKey,
        reason: persistenceReason(cause)
      },
      { cause }
    );
  }
  if (!created) {
    throw new RequestVehicleMoveError(
      RequestVehicleMoveErrorCode.PERSISTENCE_FAILED,
      "insert_scenarios_one returned null.",
      { product_key: input.product_key, scenario_key: blueprint.scenarioKey }
    );
  }
  const { move, peerMoves } = splitLegs(created.id, created.moves);
  return {
    scenario: {
      id: created.id,
      scenario_key: created.scenario_key,
      // The row was written with these; the committed values are authoritative,
      // and a null here would mean the write silently dropped identity.
      product_key: created.product_key ?? input.product_key,
      usecase_key: created.usecase_key ?? input.usecase_key,
      status: created.status
    },
    move,
    peerMoves,
    replayed: false
  };
}
function persistenceReason(cause) {
  const name = cause instanceof Error ? cause.name : void 0;
  if (name === "GraphQLServerError") {
    const code = cause.errors?.[0]?.extensions?.code;
    return typeof code === "string" && /^[a-z][a-z-]{0,39}$/.test(code) ? code : "graphql_error";
  }
  if (name === "GraphQLHttpError") return "http_error";
  if (name === "NetworkError") return "network_error";
  return "unknown";
}
async function stampLineage(result, executor, logger) {
  const pairs = missingLineage(lineagePairs(result.scenario.usecase_key, result));
  for (const pair of pairs) {
    await stampParent(result.scenario, pair, executor, logger);
  }
}
async function stampParent(scenario, { child, parentId }, executor, logger) {
  try {
    const res = await resolveExecutor20(executor).mutate(SetMoveParentDocument, {
      moveId: child.id,
      parentMoveId: parentId
    });
    const written = res.update_moves?.returning?.[0];
    if (written) child.parent_move_id = written.parent_move_id ?? null;
  } catch (cause) {
    child.parent_move_id = null;
    safeLog("warn", "move_creation.parent_link_failed", () => ({
      event: "move_creation.parent_link_failed",
      feature: "move-creation",
      boundary: "requestVehicleMove",
      scenario_id: scenario.id,
      usecase_key: scenario.usecase_key,
      child_move_id: child.id,
      parent_move_id: parentId,
      error_name: errorName(cause)
    }), logger);
  }
}
async function releaseToConfirmation(result, user, executor, logger) {
  if (result.scenario.status !== ScenarioStatus.NEW) return;
  try {
    const released = await resolveExecutor20(executor).mutate(
      ReleaseScenarioDocument,
      { scenarioId: result.scenario.id, user, now: (/* @__PURE__ */ new Date()).toISOString() }
    );
    const row = released?.update_scenarios?.returning?.[0];
    if (row?.status) result.scenario.status = row.status;
  } catch (cause) {
    safeLog("error", "move_creation.release_failed", () => ({
      event: "move_creation.release_failed",
      feature: "move-creation",
      boundary: "requestVehicleMove",
      scenario_id: result.scenario.id,
      replayed: result.replayed,
      error_name: errorName(cause)
    }), logger);
  }
}
async function findScenarioBySource(params) {
  const { customer_id, channel, request_id, executor } = params;
  if (!channel || !request_id) return null;
  return findExistingBySource(customer_id, { channel, request_id }, executor);
}
async function findExistingBySource(customerId, source, executor) {
  if (!source?.request_id || !source.channel) return null;
  let rows;
  try {
    rows = await getScenarioBySource(
      { customerId, channel: source.channel, requestId: source.request_id },
      { executor }
    );
  } catch {
    return null;
  }
  const existing = rows?.[0];
  if (!existing) return null;
  const { move, peerMoves } = splitLegs(existing.id, existing.moves);
  return {
    scenario: {
      id: existing.id,
      scenario_key: existing.scenario_key,
      product_key: existing.product_key ?? "",
      usecase_key: existing.usecase_key ?? "",
      status: existing.status
    },
    move,
    peerMoves,
    replayed: true
  };
}

// src/features/create-move/request-vehicle-move.ts
async function requestVehicleMove(params) {
  const trace = startCreationTrace("requestVehicleMove", params, params.logger);
  let result;
  try {
    result = await runRequestVehicleMove(params, trace);
  } catch (err) {
    trace.threw(err);
    throw err;
  }
  trace.succeeded(result);
  return result;
}
async function runRequestVehicleMove(params, trace) {
  const { executor, logger, ...rawInput } = params;
  const input = parseRequestInput(rawInput);
  trace.started();
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const user = input.user ?? DEFAULT_USER;
  const replay = await findExistingBySource(input.customer_id, input.source, executor);
  trace.step("replay_checked");
  if (replay) {
    await stampLineage(replay, executor, logger);
    await releaseToConfirmation(replay, user, executor, logger);
    return replay;
  }
  await assertProductSellsUseCase({
    productKey: input.product_key,
    usecaseKey: input.usecase_key,
    executor
  });
  trace.step("product_checked");
  const ctx = await resolveRequestContext({ input, now, user, executor, logger });
  trace.step("context_resolved");
  const blueprint = blueprintFor(input, ctx);
  const links = projectLiteOntoLegs(blueprint.links, input.product_key);
  trace.step("insert_submitted", { scenario_key: blueprint.scenarioKey });
  const result = await insertScenario({ input, blueprint, links, now, user, executor });
  await stampLineage(result, executor, logger);
  if (!result.replayed) {
    result.contacts = await writeContacts({
      result,
      prepared: prepareContacts(input.contacts),
      executor,
      logger
    });
  }
  await releaseToConfirmation(result, user, executor, logger);
  return result;
}

// src/features/create-move/add-move-to-scenario.ts
var VehicleSchema2 = z3.object({
  vin: z3.string().optional(),
  make: z3.string().optional(),
  model: z3.string().optional(),
  year: z3.string().optional(),
  color: z3.string().optional(),
  stock: z3.string().optional(),
  odometer: z3.number().optional(),
  manual: z3.boolean().optional(),
  gross_weight_lbs: z3.number().optional()
}).strict();
var DriveDetailSchema = z3.object({
  reference_num: z3.string().optional(),
  dealer_contact: z3.string().optional(),
  move_details: z3.string().optional(),
  workflowset_id: z3.number().int().positive().optional(),
  sla_id: z3.number().int().positive().optional(),
  payer_id: z3.number().int().positive().optional(),
  consumer_type: z3.string().optional(),
  consumer_name: z3.string().optional(),
  consumer_phone: z3.string().transform(normalizeConsumerPhone).optional(),
  consumer_pickup: z3.boolean().optional(),
  consumer_at_pickup: z3.number().int().min(0).max(1).optional(),
  class: z3.enum(["base", "stranded"]).optional(),
  chargeable: z3.boolean().optional()
});
var DRIVE_DETAIL_KEYS = Object.keys(DriveDetailSchema.shape);
var LegSchema = z3.object({
  role: z3.enum(["ride", "drive"]),
  lane_id: z3.number().int().positive(),
  ready_by: z3.string().min(1).optional(),
  pickup_time: z3.string().min(1).optional(),
  ride_type: z3.enum([RideType.AUTO, RideType.LYFT, RideType.SHUTTLE, RideType.UBER]).optional(),
  vehicle: VehicleSchema2.optional(),
  config: z3.record(z3.unknown()).optional(),
  parent_move_id: z3.number().int().positive().optional()
}).merge(DriveDetailSchema).strict().refine((leg) => leg.role === "ride" || leg.ride_type === void 0, {
  message: "ride_type is only meaningful on a ride leg",
  path: ["ride_type"]
}).refine((leg) => leg.role === "drive" || leg.parent_move_id !== void 0, {
  message: "a ride leg must name the drive it serves",
  path: ["parent_move_id"]
}).refine(
  (leg) => leg.role === "drive" || DRIVE_DETAIL_KEYS.every((key) => leg[key] === void 0),
  {
    message: `${DRIVE_DETAIL_KEYS.join(", ")} are only meaningful on a drive leg`,
    path: ["role"]
  }
);
var InputSchema = z3.object({
  /** MUST already exist. Never created here. */
  scenario_id: z3.number().int().positive(),
  /**
   * The customer the caller believes owns the scenario. A caller could have
   * obtained `scenario_id` anywhere, so without a declared customer there is
   * nothing to check ownership against and a leaked id attaches a leg to
   * somebody else's transaction.
   */
  customer_id: z3.number().int().positive(),
  leg: LegSchema,
  /** Defaults to one past the scenario's current maximum. */
  cardinality: z3.number().int().min(0).optional(),
  /** REQUIRED. 'rideshare-return' | 'scenario-repair' | 'shuttle-chase' | ... */
  reason: z3.string().trim().min(1),
  source: z3.object({
    channel: z3.string().min(1),
    request_id: z3.string().min(1).optional(),
    /** The specific origin, for the creation log. See `provenance.ts`. */
    entry_point: EntryPointSchema.optional()
  }).strict().optional(),
  /** Who initiated the call, for the creation log. See `provenance.ts`. */
  actor: ActorSchema.optional(),
  user: z3.string().min(1).optional()
}).strict();
var DEFAULT_USER2 = "sdk-moves:addMoveToScenario";
function creationStamp(reason, source) {
  const suffix = source?.request_id ? `:${source.channel}/${source.request_id}` : "";
  return `${DEFAULT_USER2}:${reason}${suffix}`;
}
function isLegAddedFor(createdBy, reason) {
  if (!createdBy) return false;
  const bare = creationStamp(reason);
  return createdBy === bare || createdBy.startsWith(`${bare}:`);
}
function deriveLite(scenario) {
  if (scenario.product_key) return isLiteProduct(scenario.product_key);
  const values = new Set(
    scenario.moves.map((link) => link.move?.lite).filter((v) => typeof v === "boolean")
  );
  if (values.size === 1) return [...values][0];
  throw new AddMoveToScenarioError(
    AddMoveToScenarioErrorCode.SCENARIO_IDENTITY_UNKNOWN,
    `Scenario ${scenario.id} records no product_key and its ${scenario.moves.length} existing leg(s) do not agree on moves.lite, so the new leg's Lite-ness cannot be derived from the scenario. Set the scenario's product_key first.`,
    {
      scenario_id: scenario.id,
      legs: scenario.moves.length,
      distinct_lite_values: [...values]
    }
  );
}
function driveDetailColumns(leg) {
  const out = {};
  for (const key of DRIVE_DETAIL_KEYS) {
    const value = leg[key];
    if (value !== void 0) out[key] = value;
  }
  return out;
}
async function driveWorkflowColumns(leg, customerId, executor) {
  if (leg.workflowset_id === void 0) return {};
  const workflowset = await resolveWorkflowset({
    inputWorkflowsetId: leg.workflowset_id,
    customerId,
    moveTime: leg.ready_by,
    executor
  });
  return effectiveWorkflows(workflowset, workflowRoleForConsumerType(leg.consumer_type));
}
function vehicleColumns2(vehicle) {
  const v = vehicle ?? {};
  return {
    vehicle_vin: v.vin,
    vehicle_make: v.make,
    vehicle_model: v.model,
    vehicle_year: v.year,
    vehicle_color: v.color,
    vehicle_stock: v.stock,
    // `moves.vehicle_odometer` is a text column but the Action declares
    // `odometer: Float`, so Hasura would reject the number. Coerced here
    // because widening it to a string would change the Action's public input.
    vehicle_odometer: v.odometer == null ? void 0 : String(v.odometer),
    ...v.manual !== void 0 ? { manual_flag: v.manual } : {},
    ...v.gross_weight_lbs !== void 0 ? { vehicle_gross_weight_lbs: v.gross_weight_lbs } : {}
  };
}
function splitAroundLeg(scenarioId, links, addedMoveId) {
  const legs = links.filter((l) => Boolean(l.move)).map((l) => toRequestedMove({ cardinality: l.cardinality, move: l.move })).sort((a, b) => a.cardinality - b.cardinality);
  const move = legs.find((m) => m.id === addedMoveId);
  if (!move) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.SCENARIO_INCOMPLETE,
      `Scenario ${scenarioId} came back without the leg that was just linked to it (move ${addedMoveId}, ${legs.length} legs read).`,
      { scenario_id: scenarioId, move_id: addedMoveId, legs: legs.length }
    );
  }
  return { move, peerMoves: legs.filter((m) => m.id !== move.id) };
}
function toRequestedScenario(scenario) {
  return {
    id: scenario.id,
    scenario_key: scenario.scenario_key,
    product_key: scenario.product_key ?? "",
    usecase_key: scenario.usecase_key ?? "",
    status: scenario.status
  };
}
async function addMoveToScenario(params) {
  const trace = startCreationTrace("addMoveToScenario", params, params.logger);
  let result;
  try {
    result = await runAddMoveToScenario(params, trace);
  } catch (err) {
    trace.threw(err);
    throw err;
  }
  trace.succeeded(result);
  return result;
}
async function runAddMoveToScenario(params, trace) {
  const { executor, logger: _logger, ...rawInput } = params;
  const parsed = InputSchema.safeParse(rawInput);
  if (!parsed.success) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.INVALID_INPUT,
      `Input failed validation: ${parsed.error.issues.map((i) => `${i.path.join(".") || "(root)"}: ${i.message}`).join("; ")}`,
      { issues: parsed.error.issues }
    );
  }
  const input = parsed.data;
  trace.started();
  let scenario;
  try {
    scenario = await getScenarioForLegAdd({ scenarioId: input.scenario_id }, { executor });
  } catch (cause) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.PERSISTENCE_FAILED,
      `Could not read scenario ${input.scenario_id}.`,
      { scenario_id: input.scenario_id },
      { cause }
    );
  }
  if (!scenario) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.SCENARIO_NOT_FOUND,
      `Scenario ${input.scenario_id} does not exist. This function attaches a leg to a scenario that already exists and never creates one; use requestVehicleMove to buy a move.`,
      { scenario_id: input.scenario_id }
    );
  }
  trace.step("context_resolved", {
    scenario_key: scenario.scenario_key,
    product_key: scenario.product_key,
    usecase_key: scenario.usecase_key
  });
  if (scenario.customer_id !== input.customer_id) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.SCENARIO_FORBIDDEN,
      `Scenario ${input.scenario_id} belongs to another customer.`,
      {
        scenario_id: input.scenario_id,
        declared_customer_id: input.customer_id
      }
    );
  }
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const stamp = creationStamp(input.reason, input.source);
  if (input.source?.request_id) {
    const already = scenario.moves.find((link2) => link2.createdby === stamp);
    if (already?.move) {
      const { move: move2, peerMoves: peerMoves2 } = splitAroundLeg(scenario.id, scenario.moves, already.move.id);
      return { scenario: toRequestedScenario(scenario), move: move2, peerMoves: peerMoves2, replayed: true };
    }
  }
  trace.step("replay_checked");
  const lite = deriveLite(scenario);
  const cardinality = input.cardinality ?? (scenario.moves.length === 0 ? 0 : Math.max(...scenario.moves.map((l) => l.cardinality)) + 1);
  const isRide = input.leg.role === "ride";
  const workflowColumns = isRide ? {} : await driveWorkflowColumns(input.leg, scenario.customer_id, executor);
  const move = {
    ...COMMON_MOVE_DEFAULTS,
    move_type: isRide ? MoveType.RIDE : MoveType.DRIVE,
    // From the scenario, not from the caller. The ownership check makes them
    // equal, and reading the scenario keeps that true by construction.
    customer_id: scenario.customer_id,
    lane_id: input.leg.lane_id,
    // A drive leg copies the scenario's use case, as `requestVehicleMove` does
    // on every drive leg, and the drive-move contract checks read it. A ride
    // leg carries none.
    lite,
    ...lite ? { payable: false } : {},
    ...isRide ? { ride_type: input.leg.ride_type ?? RideType.AUTO } : {
      ...scenario.usecase_key ? { usecase_key: scenario.usecase_key } : {},
      ...driveDetailColumns(input.leg),
      ...workflowColumns
    },
    ...input.leg.ready_by ? { ready_by: input.leg.ready_by } : {},
    ...input.leg.pickup_time ? { pickup_time: input.leg.pickup_time } : {},
    ...input.leg.parent_move_id ? { parent_move_id: input.leg.parent_move_id } : {},
    ...input.leg.config ? { config: input.leg.config } : {},
    ...vehicleColumns2(input.leg.vehicle),
    createdat: now,
    updatedat: now,
    createdBy: stamp,
    updatedBy: input.user ?? DEFAULT_USER2
  };
  const link = {
    scenario_id: scenario.id,
    cardinality,
    createdat: now,
    updatedat: now,
    createdby: stamp,
    updatedby: input.user ?? DEFAULT_USER2,
    move: { data: move }
  };
  let inserted;
  trace.step("insert_submitted");
  try {
    const result = await resolveExecutor21(executor).mutate(
      AddMoveToScenarioDocument,
      { link }
    );
    inserted = result.insert_scenariotomoves_one;
  } catch (cause) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.PERSISTENCE_FAILED,
      `The nested insert of the ${input.leg.role} leg failed.`,
      { scenario_id: scenario.id, reason: input.reason, cardinality },
      { cause }
    );
  }
  if (!inserted) {
    throw new AddMoveToScenarioError(
      AddMoveToScenarioErrorCode.PERSISTENCE_FAILED,
      "insert_scenariotomoves_one returned null.",
      { scenario_id: scenario.id, reason: input.reason }
    );
  }
  const committed = inserted.scenario;
  const { move: added, peerMoves } = splitAroundLeg(
    scenario.id,
    committed.moves,
    inserted.move_id
  );
  return {
    scenario: toRequestedScenario(committed),
    move: added,
    peerMoves,
    replayed: false
  };
}

// src/features/cancel-dependent-rides/gql/cancelDependentRideLegs.mutation.generated.ts
import { resolveExecutor as resolveExecutor22 } from "@hopdrive/sdk-core";
var CancelDependentRideLegsDocument = { "__text": 'mutation CancelDependentRideLegs($ids: [bigint!]!, $cancelReason: String!, $updatedBy: String!) {\n  update_moves(\n    where: {id: {_in: $ids}, move_type: {_eq: "ride"}, active: {_eq: 1}, _and: [{_or: [{cancel_status: {_is_null: true}}, {cancel_status: {_in: ["pending", "seen"]}}]}, {_or: [{status: {_is_null: true}}, {status: {_in: ["pending", "cancelled", "failed"]}}]}, {_not: {ridehails: {status: {_nin: ["cancelled", "failed"]}}}}]}\n    _set: {cancel_status: "canceled", canceled_at: "now()", cancel_requested_at: "now()", cancel_reason: $cancelReason, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      cancel_status\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "CancelDependentRideLegs" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "ids" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "cancelReason" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "ids" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "move_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "ride", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "pending", "block": false }, { "kind": "StringValue", "value": "seen", "block": false }] } }] } }] }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "pending", "block": false }, { "kind": "StringValue", "value": "cancelled", "block": false }, { "kind": "StringValue", "value": "failed", "block": false }] } }] } }] }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_not" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ridehails" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nin" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "cancelled", "block": false }, { "kind": "StringValue", "value": "failed", "block": false }] } }] } }] } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_status" }, "value": { "kind": "StringValue", "value": "canceled", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "canceled_at" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_requested_at" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_reason" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "cancelReason" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }] } }] } }] } }] };

// src/features/cancel-dependent-rides/cancel-dependent-rides.ts
var RIDESHARE_RETURN_REASON = "rideshare-return";
var UNDECIDED_CANCEL_STATUSES = /* @__PURE__ */ new Set(["pending", "seen"]);
var UNCALLED_RIDE_STATUSES = /* @__PURE__ */ new Set(["pending", "cancelled", "failed"]);
var TERMINAL_RIDEHAIL_STATUSES = /* @__PURE__ */ new Set(["cancelled", "failed"]);
var DEAD_DRIVE_CANCEL_STATUSES = /* @__PURE__ */ new Set(["canceled", "rescheduled"]);
function isLiveDrive(leg) {
  return !!leg && leg.move_type === "drive" && leg.active !== 0 && !(leg.cancel_status != null && DEAD_DRIVE_CANCEL_STATUSES.has(leg.cancel_status));
}
function reasonToKeep(ride, ignoreDrives = /* @__PURE__ */ new Set()) {
  if (isLegAddedFor(ride.createdBy, RIDESHARE_RETURN_REASON)) {
    return "rideshare return, booked because a drive did not run";
  }
  for (const link of ride.scenariotomoves ?? []) {
    for (const entry of link?.scenario?.moves ?? []) {
      const leg = entry?.move;
      if (leg && !ignoreDrives.has(leg.id) && isLiveDrive(leg)) return `drive ${leg.id} is still live`;
    }
  }
  if (ride.status != null && !UNCALLED_RIDE_STATUSES.has(ride.status)) {
    return `ride status is ${ride.status}`;
  }
  const liveHail = (ride.ridehails ?? []).find(
    (hail) => !(hail?.status != null && TERMINAL_RIDEHAIL_STATUSES.has(hail.status))
  );
  if (liveHail) return `ridehail ${liveHail.id} is ${liveHail.status ?? "null"}`;
  return null;
}
function isUndecidedRide(leg) {
  return leg.move_type === "ride" && leg.active !== 0 && (leg.cancel_status == null || UNDECIDED_CANCEL_STATUSES.has(leg.cancel_status));
}
function resolveDependentRidesToCancel(drive) {
  if (!drive || drive.move_type !== "drive" || drive.cancel_status !== "canceled") return { cancel: [], kept: [] };
  return decideScenarioRides(drive, /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set());
}
function decideScenarioRides(drive, ignoreDrives, skipRides) {
  const decision = { cancel: [], kept: [] };
  const seen = /* @__PURE__ */ new Set();
  for (const link of drive.scenariotomoves ?? []) {
    for (const entry of link?.scenario?.moves ?? []) {
      const leg = entry?.move;
      if (!leg || seen.has(leg.id) || skipRides.has(leg.id) || !isUndecidedRide(leg)) continue;
      seen.add(leg.id);
      const reason = reasonToKeep(leg, ignoreDrives);
      if (reason) decision.kept.push({ id: leg.id, reason });
      else decision.cancel.push(leg.id);
    }
  }
  return decision;
}
function resolveRidesLeftByReplacedDrive(drive, replacementIds) {
  if (!drive || drive.move_type !== "drive") return { cancel: [], kept: [] };
  const replacements = new Set(replacementIds);
  const replacementBroughtARide = (drive.scenariotomoves ?? []).some(
    (link) => (link?.scenario?.moves ?? []).some(
      (entry) => !!entry?.move && replacements.has(entry.move.id) && entry.move.move_type === "ride"
    )
  );
  if (!replacementBroughtARide) return { cancel: [], kept: [] };
  return decideScenarioRides(drive, /* @__PURE__ */ new Set([drive.id, ...replacementIds]), replacements);
}
async function cancelDependentRideLegs(params) {
  const executor = resolveExecutor23(params.executor);
  const read = await executor.query(
    GetCanceledDriveScenarioLegsDocument,
    { moveId: params.moveId },
    {}
  );
  const decision = resolveDependentRidesToCancel(read.moves_by_pk);
  return writeDecision(executor, decision, `Drive ${params.moveId} canceled`, params.actor);
}
async function writeDecision(executor, decision, cancelReason, actor) {
  if (decision.cancel.length === 0) return { canceled: [], kept: decision.kept };
  const write = await executor.mutate(CancelDependentRideLegsDocument, {
    ids: decision.cancel,
    cancelReason,
    updatedBy: actor || "system"
  });
  const canceled = (write.update_moves?.returning ?? []).map((row) => row.id);
  const raced = decision.cancel.filter((id2) => !canceled.includes(id2)).map((id2) => ({ id: id2, reason: "changed before the write" }));
  return { canceled, kept: [...decision.kept, ...raced] };
}
async function retireRideLegsOfReplacedDrive(params) {
  const executor = resolveExecutor23(params.executor);
  const read = await executor.query(
    GetCanceledDriveScenarioLegsDocument,
    { moveId: params.moveId },
    {}
  );
  const decision = resolveRidesLeftByReplacedDrive(read.moves_by_pk, params.replacementIds);
  return writeDecision(executor, decision, params.reason, params.actor);
}

// src/features/create-move/move-type-usecases.ts
var MOVE_TYPE_USECASES = Object.freeze(
  [
    {
      type: MoveRequestType.CONCIERGE,
      direction: MoveRequestDirection.PICKUP,
      usecaseKey: UseCaseKey.CONCIERGE_PICKUP
    },
    {
      type: MoveRequestType.CONCIERGE,
      direction: MoveRequestDirection.RETURN,
      usecaseKey: UseCaseKey.CONCIERGE_RETURN
    },
    {
      type: MoveRequestType.CONCIERGE_LOANER,
      direction: MoveRequestDirection.PICKUP,
      usecaseKey: UseCaseKey.CONCIERGE_LOANER_PICKUP
    },
    {
      type: MoveRequestType.CONCIERGE_LOANER,
      direction: MoveRequestDirection.RETURN,
      usecaseKey: UseCaseKey.CONCIERGE_LOANER_RETURN
    },
    { type: MoveRequestType.ONE_WAY, direction: null, usecaseKey: UseCaseKey.ONE_WAY },
    { type: MoveRequestType.ROUND_TRIP, direction: null, usecaseKey: UseCaseKey.ROUND_TRIP }
  ].map((row) => Object.freeze(row))
);
function usecasesForMoveType(type) {
  return MOVE_TYPE_USECASES.filter((row) => row.type === type).map((row) => row.usecaseKey);
}
function isDirectionalType(type) {
  return MOVE_TYPE_USECASES.some((row) => row.type === type && row.direction !== null);
}
function usecaseKeyForMoveType(type, direction) {
  const wanted = isDirectionalType(type) ? direction ?? null : null;
  return MOVE_TYPE_USECASES.find((row) => row.type === type && row.direction === wanted)?.usecaseKey;
}

// src/features/create-move/product-offering.ts
function sellersFor(type, ownedProductKeys, canCreate, compatibility) {
  const selling = new Set(
    usecasesForMoveType(type).flatMap(
      (usecaseKey) => productsSelling(usecaseKey, ownedProductKeys, compatibility)
    )
  );
  return Object.keys(compatibility).filter((key) => selling.has(key) && canCreate(key));
}
function defaultSellerOf(sellers) {
  if (sellers.length === 1) return sellers[0];
  const liteSellers = sellers.filter((key) => isLiteProduct(key));
  if (liteSellers.length === 1) return liteSellers[0];
  return VALET_TIER_TIE_BREAK.find((key) => sellers.includes(key)) ?? null;
}
function offeringFor(sellers) {
  return {
    offered: sellers.length > 0,
    sellers,
    requiresChoice: sellers.length > 1,
    defaultSeller: defaultSellerOf(sellers)
  };
}
function resolveMoveOffering(params) {
  const { ownedProductKeys, canCreate, compatibility = PRODUCT_USECASE_COMPATIBILITY } = params;
  const offerings = {};
  for (const type of Object.values(MoveRequestType)) {
    offerings[type] = offeringFor(sellersFor(type, ownedProductKeys, canCreate, compatibility));
  }
  return offerings;
}

// src/features/request-mapping/declared-product.ts
var UnmappedRequestTypeError = class extends Error {
  constructor(integration, requestType, declaredTypes) {
    super(
      `${integration}: no product is declared for request type "${requestType}". Declared types: ${declaredTypes.join(", ")}. Add a row to PRODUCT_FOR_REQUEST_TYPE once the product owner decides which product it sells.`
    );
    this.code = "UNMAPPED_REQUEST_TYPE";
    this.name = "UnmappedRequestTypeError";
    this.integration = integration;
    this.requestType = requestType;
  }
};
function declareProductsForRequestTypes(integration, table) {
  class IntegrationUnmappedRequestTypeError extends UnmappedRequestTypeError {
    constructor(requestType) {
      super(integration, requestType, Object.keys(table));
    }
  }
  return {
    resolveProductForRequestType(requestType) {
      const productKey = Object.prototype.hasOwnProperty.call(table, requestType) ? table[requestType] : void 0;
      if (!productKey) throw new IntegrationUnmappedRequestTypeError(requestType);
      return productKey;
    },
    UnmappedRequestTypeError: IntegrationUnmappedRequestTypeError
  };
}

// src/features/request-mapping/partner-one-way.ts
function defaultThirdPartyPayer(customerConfig, customerId) {
  const config = customerConfig ?? {};
  const defaultPayer = config.default_payer;
  return config.require_third_party_payer && defaultPayer && Number(defaultPayer) !== Number(customerId) ? Number(defaultPayer) : void 0;
}
async function requestPartnerOneWayMove(params, deps) {
  const { integration, subject, productKey, request, source, user, correlationId } = params;
  const actor = params.actor ?? { type: "integrator", id: integration };
  const { customerId } = request;
  const [pickup, delivery] = await Promise.all(
    [request.pickup, request.delivery].map(async (supplied) => {
      const resolved = await deps.resolveLocation({
        customerId,
        name: supplied.name,
        address: supplied.address,
        // Forwarded only when the partner's mapping has a second line at all.
        ..."addressLineTwo" in supplied ? { addressLineTwo: supplied.addressLineTwo } : {},
        correlationId
      });
      if (!resolved?.resolved || !resolved.location) {
        throw new Error(
          `${integration}: a supplied address could not be resolved to one location (${subject}, "${supplied.address}").`
        );
      }
      return resolved.location;
    })
  );
  const lanes = await deps.resolveLaneWithRouting({
    customerId,
    originLocationId: pickup.id,
    destinationLocationId: delivery.id,
    correlationId
  });
  if (!lanes?.lane || !lanes.inverse) {
    throw new Error(`${integration}: the route could not be prepared for move creation (${subject}).`);
  }
  const payerId = defaultThirdPartyPayer(
    await deps.getCustomerConfig({ customerId }),
    customerId
  );
  const input = {
    customer_id: customerId,
    product_key: productKey,
    usecase_key: "one-way",
    lane_id: lanes.lane.id,
    ready_by: request.readyBy,
    // Every one-way gets a `stranded-rideshare-after` ride, matching what the
    // scenario backstop builds unconditionally.
    includeRide: true,
    rideLaneId: lanes.inverse.id,
    reference_num: request.referenceNum,
    dealer_contact: request.dealerContact,
    move_details: request.moveDetails,
    config: request.config,
    vehicle: request.vehicle,
    ...request.workflowsetId !== void 0 ? { workflowset_id: request.workflowsetId } : {},
    ...request.contacts !== void 0 ? { contacts: request.contacts } : {},
    ...payerId !== void 0 ? { payer_id: payerId } : {},
    source,
    actor,
    user
  };
  return deps.requestVehicleMove(input);
}

// src/features/request-mapping/dealer-request.ts
var DealerRequestErrorCode = {
  /** A request type with no use case declared for it. */
  UNMAPPED_REQUEST_TYPE: "UNMAPPED_REQUEST_TYPE",
  /** A concierge-family request whose `customer_action` is not `pickup` or `return`. */
  INVALID_CUSTOMER_ACTION: "INVALID_CUSTOMER_ACTION",
  /** A requested time that does not parse. `details.field` names the field. */
  INVALID_REQUESTED_TIME: "INVALID_REQUESTED_TIME",
  /** A pickup or delivery location that is absent. */
  LOCATION_MISSING: "LOCATION_MISSING",
  /** A location with neither `full_address` nor `address_one`, `city` and `state`. */
  LOCATION_INCOMPLETE: "LOCATION_INCOMPLETE"
};
var DealerRequestError = class extends Error {
  constructor(code, message, details) {
    super(message);
    this.name = "DealerRequestError";
    this.code = code;
    if (details !== void 0) this.details = details;
  }
};
function isDealerRequestError(error) {
  if (!error || typeof error !== "object") return false;
  const candidate = error;
  return candidate.name === "DealerRequestError" && Object.values(DealerRequestErrorCode).includes(candidate.code);
}
function useCasesByRequestType() {
  const byType = {};
  for (const { type, direction, usecaseKey } of MOVE_TYPE_USECASES) {
    byType[type] = direction === null ? usecaseKey : { ...byType[type], [direction]: usecaseKey };
  }
  for (const value of Object.values(byType)) Object.freeze(value);
  return Object.freeze(byType);
}
var DEALER_REQUEST_USE_CASES = useCasesByRequestType();
var CONCIERGE_KINDS = /* @__PURE__ */ new Set([MoveRequestType.CONCIERGE, MoveRequestType.CONCIERGE_LOANER]);
function dealerUseCaseKey(kind, customerAction) {
  if (usecasesForMoveType(kind).length === 0) {
    throw new DealerRequestError(
      DealerRequestErrorCode.UNMAPPED_REQUEST_TYPE,
      `No use case is declared for request type "${kind}".`,
      { requestType: kind }
    );
  }
  const usecaseKey = usecaseKeyForMoveType(
    kind,
    typeof customerAction === "string" ? customerAction : null
  );
  if (!usecaseKey) {
    throw new DealerRequestError(
      DealerRequestErrorCode.INVALID_CUSTOMER_ACTION,
      `A ${kind} request needs customer_action "pickup" or "return".`,
      { requestType: kind }
    );
  }
  return usecaseKey;
}
function dealerRequestedTime(kind, request) {
  const field = CONCIERGE_KINDS.has(kind) ? "appointment_time_utc" : "ready_by_time_utc";
  const value = request[field];
  const parsed = typeof value === "string" ? Date.parse(value) : Number.NaN;
  if (!Number.isFinite(parsed)) {
    throw new DealerRequestError(
      DealerRequestErrorCode.INVALID_REQUESTED_TIME,
      `${field} must be a valid timestamp.`,
      { field, value }
    );
  }
  return value;
}
function dealerLocationAddress(location) {
  if (!location || typeof location !== "object") {
    throw new DealerRequestError(
      DealerRequestErrorCode.LOCATION_MISSING,
      "A pickup or delivery location is missing."
    );
  }
  const place = location;
  if (typeof place.full_address === "string" && place.full_address.trim()) {
    return place.full_address.trim();
  }
  if (!place.address_one || !place.city || !place.state) {
    throw new DealerRequestError(
      DealerRequestErrorCode.LOCATION_INCOMPLETE,
      "A location needs full_address, or address_one, city and state."
    );
  }
  const present = (part) => Boolean(part?.trim());
  const locality = [place.city, place.state, place.zip].filter(present).join(" ");
  return [place.address_one, place.address_two, locality].filter(present).join(", ");
}
function dealerRequestEndpoints(kind, customerAction, request) {
  if (kind === "one-way") {
    return { origin: request.move?.pickup_location, destination: request.move?.delivery_location };
  }
  if (kind === "round-trip") {
    return {
      origin: request.move_one?.pickup_location,
      destination: request.move_two?.pickup_location
    };
  }
  if (kind === "concierge") {
    return {
      origin: request.customer_move?.pickup_location,
      destination: request.customer_move?.delivery_location
    };
  }
  if (kind === "concierge-loaner") {
    return customerAction === "return" ? {
      origin: request.customer_move?.pickup_location,
      destination: request.loaner_move?.pickup_location
    } : {
      origin: request.loaner_move?.pickup_location,
      destination: request.customer_move?.pickup_location
    };
  }
  throw new DealerRequestError(
    DealerRequestErrorCode.UNMAPPED_REQUEST_TYPE,
    `No use case is declared for request type "${kind}".`,
    { requestType: kind }
  );
}
function dealerPrimaryMove(kind, request) {
  if (kind === "one-way") return request.move;
  if (kind === "round-trip") return request.move_one;
  return request.customer_move;
}
function compactDefined(value) {
  return Object.fromEntries(
    Object.entries(value).filter(([, item]) => item !== void 0)
  );
}
function fieldReader(options) {
  return (value) => (options.fromSpreadsheet || options.nullIsAbsent) && value === null ? void 0 : value;
}
function idReader(options) {
  const read = fieldReader(options);
  return (value) => {
    const id2 = read(value);
    return options.fromSpreadsheet && typeof id2 === "string" && /^\s*\d+\s*$/.test(id2) ? Number(id2) : id2;
  };
}
function dealerVehicle(move, options = {}) {
  const read = fieldReader(options);
  const vehicle = move?.vehicle || {};
  const year = read(vehicle.year);
  const mapped = compactDefined({
    vin: read(vehicle.vin),
    stock: read(vehicle.stock),
    year: options.fromSpreadsheet && year !== void 0 ? String(year) : year,
    make: read(vehicle.make),
    model: read(vehicle.model),
    color: read(vehicle.color),
    manual: read(vehicle.manual),
    gross_weight_lbs: read(vehicle.gross_weight_lbs)
  });
  if (options.fromSpreadsheet && Object.keys(mapped).length === 0) return void 0;
  return mapped;
}
function dealerSharedMoveInput(move, options = {}) {
  const read = fieldReader(options);
  const readId = idReader(options);
  return compactDefined({
    vehicle: dealerVehicle(move, options),
    reference_num: read(move?.reference_num),
    dealer_contact: read(move?.dealer_contact),
    move_details: read(move?.special_instructions),
    config: read(move?.config),
    workflowset_id: readId(move?.workflowset_id),
    sla_id: readId(move?.sla_id),
    pickup_workflow_data: read(move?.pickup_workflow_data),
    delivery_workflow_data: read(move?.delivery_workflow_data)
  });
}
function dealerLegInput(move, laneId, readyBy, options) {
  const read = fieldReader(options);
  const readId = idReader(options);
  return compactDefined({
    lane_id: laneId,
    vehicle: dealerVehicle(move, options),
    ready_by: readyBy,
    reference_num: read(move?.reference_num),
    dealer_contact: read(move?.dealer_contact),
    move_details: read(move?.special_instructions),
    config: read(move?.config),
    workflowset_id: readId(move?.workflowset_id),
    sla_id: readId(move?.sla_id),
    pickup_workflow_data: read(move?.pickup_workflow_data),
    delivery_workflow_data: read(move?.delivery_workflow_data)
  });
}
function dealerLegInputs(params) {
  const { kind, customerAction, request, laneId, inverseLaneId, readyBy } = params;
  const options = {
    fromSpreadsheet: params.fromSpreadsheet,
    nullIsAbsent: params.nullIsAbsent
  };
  if (kind === "one-way") {
    return { includeRide: true, rideLaneId: inverseLaneId };
  }
  if (kind === "concierge") {
    return params.rideshareCallingEnabled !== false ? { includeRide: true, rideLaneId: inverseLaneId } : {};
  }
  if (kind === "concierge-loaner") {
    const customerFirst = customerAction === "return";
    return {
      lane_id: customerFirst ? laneId : inverseLaneId,
      loanerLeg: dealerLegInput(
        request.loaner_move,
        customerFirst ? inverseLaneId : laneId,
        readyBy,
        options
      )
    };
  }
  if (kind === "round-trip") {
    return { returnLeg: dealerLegInput(request.move_two, inverseLaneId, readyBy, options) };
  }
  return {};
}
export {
  ACTOR_TYPES,
  AddMoveToScenarioError,
  AddMoveToScenarioErrorCode,
  CONTACT_FIELD_MAX_LENGTH,
  CancelStatus,
  ConsumerType,
  DEALER_REQUEST_USE_CASES,
  DealerRequestError,
  DealerRequestErrorCode,
  LITE_PRODUCT_KEYS,
  LIVE_REGION_STATUS,
  MOVE_TYPE_USECASES,
  MoveRequestDirection,
  MoveRequestType,
  MoveRole,
  MoveStatus,
  MoveType,
  PRODUCT_USECASE_COMPATIBILITY,
  ProductSelectionOutcome,
  RIDESHARE_RETURN_REASON,
  RequestVehicleMoveError,
  RequestVehicleMoveErrorCode,
  RideType,
  SERVICE_RADIUS_GRACE_MILES,
  SUPPORTED_USE_CASE_KEYS,
  ScenarioKey,
  ScenarioStatus,
  UnmappedRequestTypeError,
  UseCaseKey,
  VALET_TIER_TIE_BREAK,
  actorFromHasuraSession,
  addMoveToScenario,
  cancelDependentRideLegs,
  createFetchExecutor,
  dealerLegInputs,
  dealerLocationAddress,
  dealerPrimaryMove,
  dealerRequestEndpoints,
  dealerRequestedTime,
  dealerSharedMoveInput,
  dealerUseCaseKey,
  dealerVehicle,
  declareProductsForRequestTypes,
  defaultThirdPartyPayer,
  evaluateMoveLocations,
  findScenarioBySource,
  getMove,
  init,
  isAddMoveToScenarioError,
  isDealerRequestError,
  isEmbedHmacSession,
  isLiteProduct,
  isRequestVehicleMoveError,
  normalizeConsumerPhone,
  productsSelling,
  requestPartnerOneWayMove,
  requestVehicleMove,
  resetDefaultExecutor,
  resolveDependentRidesToCancel,
  resolveExecutor24 as resolveExecutor,
  resolveMoveOffering,
  resolveRidesLeftByReplacedDrive,
  retireRideLegsOfReplacedDrive,
  selectOwnedProduct,
  updateMove,
  usecaseKeyForMoveType,
  usecasesForMoveType
};
//# sourceMappingURL=index.mjs.map